import { CSSProperties } from "react"

const FacebookIcon = () => {
    return(
           <svg xmlns="http://www.w3.org/2000/svg" width={35} viewBox="0 0 64 64">
    <g id="SVGRepo_iconCarrier" fill="white">
      <path d="M44 7H20A13 13 0 0 0 7 20v24a13 13 0 0 0 13 13h24a13 13 0 0 0 13-13V20A13 13 0 0 0 44 7M33 55V38a1 1 0 0 0-1-1h-5v-6h5a1 1 0 0 0 1-1v-8a5 5 0 0 1 5-5h8v6h-4a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1h6v6h-6a1 1 0 0 0-1 1v17Zm22-11a11 11 0 0 1-11 11h-3V39h6a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-6v-3a1 1 0 0 1 1-1h5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-9a7 7 0 0 0-7 7v7h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5v16H20A11 11 0 0 1 9 44V20A11 11 0 0 1 20 9h24a11 11 0 0 1 11 11Z"></path>
    </g>
  </svg>
    )
}
const InstagramIcon = ()=> {
    return(
         <svg xmlns="http://www.w3.org/2000/svg" width={35} fill="white" viewBox="0 0 64 64">
    <g id="SVGRepo_iconCarrier">
      <path d="M44 57H20A13 13 0 0 1 7 44V20A13 13 0 0 1 20 7h24a13 13 0 0 1 13 13v24a13 13 0 0 1-13 13M20 9A11 11 0 0 0 9 20v24a11 11 0 0 0 11 11h24a11 11 0 0 0 11-11V20A11 11 0 0 0 44 9Z"></path>
      <path d="M32 43.67A11.67 11.67 0 1 1 43.67 32 11.68 11.68 0 0 1 32 43.67m0-21.33A9.67 9.67 0 1 0 41.67 32 9.68 9.68 0 0 0 32 22.33ZM44.5 21a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5m0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5"></path>
    </g>
  </svg>
    )
}
interface CheckMarkCircle{
  color?:string
}
const CheckMarkCircle = ({color}:CheckMarkCircle) => {
    return(
        <svg  style={{ display: "block", width: '30px', height: '30px' }} xmlns="http://www.w3.org/2000/svg" width={'30px'} height={'30px'} viewBox="0 0 24 24" fill="#8fae70">
    <path
    stroke={color ??"#8fae70"}
      id="SVGRepo_iconCarrier"
      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-1a9 9 0 1 0 0-18 9 9 0 0 0 0 18m3.146-11.854a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708l1.646 1.647z"
    ></path>
  </svg>
    )
}
const CheckMarkCross = () => {
    return(
        <svg width="30px"
  height="30px"
  viewBox="0 0 24 24"
  fill="none"
  preserveAspectRatio="xMidYMid meet"
  style={{ display: "block" }}
 xmlns="http://www.w3.org/2000/svg"  >
    <g id="SVGRepo_iconCarrier">
      <path
       
        fillRule="evenodd"
        stroke="#b14100"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.7"
        d="M5.5 12a7 7 0 1 1 14 .001 7 7 0 0 1-14 0"
        clipRule="evenodd"
      ></path>
      <path
        fill="#b14100"
        d="M9.345 14.094a.75.75 0 0 0 1.06 1.06zm3.685-1.563a.75.75 0 1 0-1.06-1.061zm-1.06-1.061a.75.75 0 0 0 1.06 1.06zm3.685-1.566a.75.75 0 0 0-1.061-1.06zM13.03 11.47a.75.75 0 0 0-1.06 1.06zm1.565 3.685a.75.75 0 0 0 1.06-1.061zM11.97 12.53a.75.75 0 0 0 1.06-1.06zm-1.565-3.686a.75.75 0 1 0-1.06 1.06zm0 6.31 2.625-2.623-1.06-1.061-2.625 2.624zm2.626-2.624 2.624-2.626-1.061-1.06-2.624 2.626zm-1.061 0 2.625 2.625 1.06-1.061-2.625-2.624zm1.06-1.06-2.625-2.626-1.06 1.06 2.625 2.626z"
      ></path>
    </g>
  </svg>
    )
}

const LinkedInIcon = () => {
  return(
    
     <svg fill="white"  style={{ display: "block", width: '35px', height: '35px' }}   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g id="SVGRepo_iconCarrier">
      <path d="M44 7H20A13 13 0 0 0 7 20v24a13 13 0 0 0 13 13h24a13 13 0 0 0 13-13V20A13 13 0 0 0 44 7m11 37a11 11 0 0 1-11 11H20A11 11 0 0 1 9 44V20A11 11 0 0 1 20 9h24a11 11 0 0 1 11 11Z"></path>
      <path d="M22 25h-7a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V26a1 1 0 0 0-1-1m-1 23h-5V27h5ZM42 25a14.2 14.2 0 0 0-7 2.11V26a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V33.81a7.7 7.7 0 0 1 3-.81c2.81 0 3 2 3 2.44V49a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V33.17a8.3 8.3 0 0 0-2.14-6.11A7.93 7.93 0 0 0 42 25m6 23h-5V35.44C43 33.9 42 31 38 31a10.24 10.24 0 0 0-4.45 1.29 1 1 0 0 0-.55.89V48h-5V27h5v2.06a1 1 0 0 0 1.66.75A12.3 12.3 0 0 1 42 27a6 6 0 0 1 4.42 1.47 6.4 6.4 0 0 1 1.58 4.7ZM18.5 14a4.5 4.5 0 1 0 4.5 4.5 4.5 4.5 0 0 0-4.5-4.5m0 7a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5"></path>
    </g>
  </svg>
  
  )
}
const MenuIcon = () => {
  return(
     <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6h16M4 12h16M4 18h16"
    ></path>
  </svg>
  //    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="30px"
  // height="30px">
  //   <g id="SVGRepo_iconCarrier" stroke="#E16A54">
  //     <path
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="2"
  //       d="M8 12h.009m3.996 0h.008m3.978 0H16"
  //     ></path>
  //     <path
  //       strokeWidth="1.5"
  //       d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"
  //     ></path>
  //   </g>
  // </svg>
  )
}
interface LogoIconProps {
  width?: number;
  height?: number;
}

const KlarnaWhite = ({ width = 150, height = 50 }: LogoIconProps) => {
  return(
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 226 96"
  >
    <path stroke="#fff" strokeWidth="2" d="M225.266 1h-225"></path>
    <path
      fill="#fff"
      d="M204.147 85.895c-5.233 0-9.311-4.32-9.311-9.565 0-5.246 4.078-9.566 9.311-9.566s9.311 4.32 9.311 9.566c0 5.245-4.079 9.565-9.311 9.565M201.53 96c4.464 0 10.158-1.697 13.313-8.331l.308.154c-1.386 3.626-1.386 5.786-1.386 6.326v.848H225V57.662h-11.235v.849c0 .54 0 2.7 1.386 6.325l-.308.154c-3.155-6.634-8.849-8.33-13.313-8.33-10.696 0-18.237 8.484-18.237 19.67 0 11.185 7.541 19.67 18.237 19.67m-37.782-39.34c-5.078 0-9.08 1.773-12.312 8.33l-.307-.154c1.385-3.626 1.385-5.785 1.385-6.325v-.849h-11.235v37.335h11.542v-19.67c0-5.168 3.002-8.408 7.849-8.408s7.234 2.777 7.234 8.33v19.748h11.542V71.238c0-8.485-6.618-14.579-15.698-14.579m-39.167 8.33-.308-.154c1.385-3.626 1.385-5.785 1.385-6.325v-.849h-11.234v37.335h11.542l.077-17.973c0-5.246 2.77-8.408 7.31-8.408 1.231 0 2.232.154 3.386.463V57.662c-5.079-1.08-9.619.849-12.158 7.328M87.876 85.895c-5.232 0-9.31-4.32-9.31-9.565 0-5.246 4.078-9.566 9.31-9.566s9.311 4.32 9.311 9.566c0 5.245-4.078 9.565-9.31 9.565M85.26 96c4.463 0 10.157-1.697 13.312-8.331l.308.154c-1.385 3.626-1.385 5.786-1.385 6.326v.848h11.234V57.662H97.495v.849c0 .54 0 2.7 1.385 6.325l-.308.154c-3.155-6.634-8.849-8.33-13.312-8.33-10.696 0-18.237 8.484-18.237 19.67C67.023 87.515 74.564 96 85.26 96m-34.32-1.003h11.543V41H50.94zM42.477 41H30.703c0 9.642-5.925 18.282-14.928 24.453l-3.54 2.468V41H0v53.997h12.235V68.23l20.238 26.767H47.4l-19.468-25.61C36.782 62.985 42.553 53.034 42.476 41"
    ></path>
  </svg>
  )
}
const KlarnaOffWhiteTransparent = ({ width = 100, height = 50 }: LogoIconProps) => {
  return(
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 1611 783"
  >
    <path
      fill="#F9F8F5"
      d="M1249.17 478.005c-25.25 0-44.93-20.88-44.93-46.234s19.68-46.235 44.93-46.235 44.93 20.88 44.93 46.235c0 25.354-19.68 46.234-44.93 46.234m-12.63 48.845c21.54 0 49.02-8.203 64.25-40.269l1.48.746c-6.68 17.524-6.68 27.964-6.68 30.575v4.101h54.21V341.538h-54.21v4.102c0 2.61 0 13.05 6.68 30.574l-1.48.746c-15.23-32.066-42.71-40.269-64.25-40.269-51.61 0-88 41.015-88 95.08s36.39 95.079 88 95.079m-182.32-190.159c-24.51 0-43.82 8.576-59.419 40.269l-1.485-.746C1000 358.69 1000 348.25 1000 345.64v-4.102h-54.216v180.465h55.706v-95.08c0-24.981 14.48-40.642 37.87-40.642 23.4 0 34.91 13.423 34.91 40.269v95.453h55.7V407.162c0-41.015-31.94-70.471-75.75-70.471M865.203 376.96l-1.486-.746c6.684-17.524 6.684-27.964 6.684-30.574v-4.102h-54.215v180.465h55.701l.371-86.877c0-25.354 13.368-40.642 35.278-40.642 5.941 0 10.769.746 16.339 2.238v-55.184c-24.509-5.22-46.418 4.102-58.672 35.422m-177.13 101.045c-25.252 0-44.933-20.88-44.933-46.234s19.681-46.235 44.933-46.235 44.932 20.88 44.932 46.235c0 25.354-19.681 46.234-44.932 46.234m-12.626 48.845c21.538 0 49.017-8.203 64.242-40.269l1.485.746c-6.684 17.524-6.684 27.964-6.684 30.575v4.101h54.216V341.538H734.49v4.102c0 2.61 0 13.05 6.684 30.574l-1.485.746c-15.225-32.066-42.704-40.269-64.242-40.269-51.617 0-88.008 41.015-88.008 95.08s36.391 95.079 88.008 95.079m-165.619-4.847h55.702V261h-55.702zM468.981 261h-56.816c0 46.608-28.593 88.368-72.04 118.197l-17.082 11.932V261H264v261.003h59.043V392.62l97.663 129.383h72.041l-93.95-123.79c42.704-30.947 70.555-79.047 70.184-137.213"
    ></path>
  </svg>
  )
}
interface HeartProps{
  width?:number;
  height?:number;
  fillOutlineColor?:string;
}
const Heart = ({width,height,fillOutlineColor}:HeartProps) => {
  return(
  //   <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 24 24">
  //   <g id="SVGRepo_iconCarrier">
  //     <path  d="M0 0h24v24H0z"></path>
  //     <path
  //       stroke="#E16A54"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       d="M21 9c0 3.754-5.284 8.976-8.414 11.533a.955.955 0 0 1-1.187.02C8.267 18.152 3 13.122 3 9c0-7 9-7 9-1 0-6 9-6 9 1"
  //     ></path>
  //   </g>
  // </svg>
   <svg
    width={width ??20}
    height={height ?? 20}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    fill="#000"
    version="1"
    viewBox="0 0 64 64"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#E16A54"
        d="M58.714 29.977s-.612.75-1.823 1.961L33.414 55.414c-.391.391-.902.586-1.414.586s-1.023-.195-1.414-.586L7.109 31.937c-1.211-1.211-1.823-1.961-1.823-1.961C3.245 27.545 2 24.424 2 21 2 13.268 8.268 7 16 7c3.866 0 7.366 1.566 9.899 4.101l.009-.009 4.678 4.677a2 2 0 0 0 2.828 0l4.678-4.677.009.009A13.95 13.95 0 0 1 48 7c7.732 0 14 6.268 14 14 0 3.424-1.245 6.545-3.286 8.977"
      ></path>
      <path
        fill="#E16A54"
        d="M58.714 29.977s-.612.75-1.823 1.961L33.414 55.414c-.391.391-.902.586-1.414.586s-1.023-.195-1.414-.586L7.109 31.937c-1.211-1.211-1.823-1.961-1.823-1.961C3.245 27.545 2 24.424 2 21 2 13.268 8.268 7 16 7c3.866 0 7.366 1.566 9.899 4.101l.009-.009 4.678 4.677a2 2 0 0 0 2.828 0l4.678-4.677.009.009A13.95 13.95 0 0 1 48 7c7.732 0 14 6.268 14 14 0 3.424-1.245 6.545-3.286 8.977"
      ></path>
      <g fill={fillOutlineColor ?? "#394240"}>
        <path d="M48 5a15.95 15.95 0 0 0-11.313 4.687l-3.979 3.961a1 1 0 0 1-1.414 0s-3.971-3.97-3.979-3.961A15.95 15.95 0 0 0 16 5C7.163 5 0 12.163 0 21c0 3.338 1.024 6.436 2.773 9 0 0 .734 1.164 1.602 2.031l24.797 24.797C29.953 57.609 30.977 58 32 58s2.047-.391 2.828-1.172l24.797-24.797c.867-.867 1.602-2.031 1.602-2.031A15.9 15.9 0 0 0 64 21c0-8.837-7.163-16-16-16m10.714 24.977s-.612.75-1.823 1.961L33.414 55.414c-.391.391-.902.586-1.414.586s-1.023-.195-1.414-.586L7.109 31.937c-1.211-1.211-1.823-1.961-1.823-1.961C3.245 27.545 2 24.424 2 21 2 13.268 8.268 7 16 7c3.866 0 7.366 1.566 9.899 4.101l.009-.009 4.678 4.677a2 2 0 0 0 2.828 0l4.678-4.677.009.009A13.95 13.95 0 0 1 48 7c7.732 0 14 6.268 14 14 0 3.424-1.245 6.545-3.286 8.977"></path>
        <path d="M48 11a1 1 0 1 0 0 2 8 8 0 0 1 8 8 1 1 0 1 0 2 0c0-5.522-4.478-10-10-10"></path>
      </g>
    </g>
  </svg>
  )
}
const Brain = () => {
  
  return(
    <svg
    width={40}
    height={40}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1_1_"
    fill="rgb(225 106 84)"
    version="1.1"
    viewBox="0 0 64 64"
  >
    <g id="SVGRepo_iconCarrier">
      <path d="M63 26c0-3.433-2.007-6.561-5.05-8.06q.049-.463.05-.94c0-4.963-4.038-9-9-9-.076 0-.151.013-.228.015C47.865 4.005 44.28 1 40 1c-3.483 0-6.505 1.993-8 4.896C30.505 2.993 27.483 1 24 1a8.99 8.99 0 0 0-8.775 7.011C15.15 8.01 15.076 8 15 8c-4.962 0-9 4.037-9 9q0 .458.049.922C2.999 19.42 1 22.57 1 26c0 2.303.877 4.4 2.305 5.993A9 9 0 0 0 1 38c0 3.432 2.007 6.561 5.05 8.06q-.049.463-.05.94c0 4.963 4.038 9 9 9 .076 0 .15-.01.225-.011A8.99 8.99 0 0 0 24 63c3.483 0 6.505-1.993 8-4.896C33.495 61.007 36.517 63 40 63c4.28 0 7.865-3.005 8.772-7.015.077.002.152.015.228.015 4.962 0 9-4.037 9-9q0-.457-.049-.922C61.001 44.581 63 41.43 63 38c0-2.303-.877-4.4-2.305-5.993A9 9 0 0 0 63 26m-6.507 18.533-.785.3.16.825c.088.452.132.904.132 1.342 0 3.859-3.14 7-7 7 0-4.963-4.038-9-9-9v2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7V16h-2v38c0 3.859-3.14 7-7 7a6.99 6.99 0 0 1-6.783-5.288C21.109 54.721 24 51.196 24 47h-2c0 3.859-3.14 7-7 7s-7-3.141-7-7 3.14-7 7-7v-2c-3.932 0-7.275 2.539-8.497 6.06C4.372 42.824 3 40.51 3 38c0-1.734.647-3.395 1.793-4.673A8.94 8.94 0 0 0 10 35v-2c-3.86 0-7-3.141-7-7 0-2.878 1.812-5.504 4.507-6.533l.786-.301-.161-.825A7 7 0 0 1 8 17c0-3.859 3.14-7 7-7s7 3.141 7 7h2c0-4.196-2.891-7.721-6.783-8.712A6.99 6.99 0 0 1 24 3c3.86 0 7 3.141 7 7v4h2v-4c0-3.859 3.14-7 7-7s7 3.141 7 7-3.14 7-7 7v2c4.962 0 9-4.037 9-9 3.86 0 7 3.141 7 7s-3.14 7-7 7v2c3.932 0 7.275-2.539 8.497-6.061A7.05 7.05 0 0 1 61 26a7 7 0 0 1-1.793 4.673A8.94 8.94 0 0 0 54 29c-4.962 0-9 4.037-9 9h2c0-3.859 3.14-7 7-7s7 3.141 7 7c0 2.878-1.812 5.504-4.507 6.533"></path>
      <path d="M43 10h2c0-2.757-2.243-5-5-5v2c1.654 0 3 1.346 3 3M37 54h-2c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3M54 41v2c2.757 0 5-2.243 5-5h-2c0 1.654-1.346 3-3 3M39 37h-2c0 3.309 2.691 6 6 6v-2c-2.206 0-4-1.794-4-4M41 23v-2c-3.309 0-6 2.691-6 6h2c0-2.206 1.794-4 4-4M25 37h-2c0 3.309 2.691 6 6 6v-2c-2.206 0-4-1.794-4-4M40 28h-2c0 3.309 2.691 6 6 6v-2c-2.206 0-4-1.794-4-4M27 23v-2c-3.309 0-6 2.691-6 6h2c0-2.206 1.794-4 4-4M14 36h2c0-2.206 1.794-4 4-4v-2c-3.309 0-6 2.691-6 6M15 50v2c2.757 0 5-2.243 5-5h-2c0 1.654-1.346 3-3 3M5 26h2c0-1.654 1.346-3 3-3v-2c-2.757 0-5 2.243-5 5M15 12v2c1.654 0 3 1.346 3 3h2c0-2.757-2.243-5-5-5M24 5v2c1.654 0 3 1.346 3 3h2c0-2.757-2.243-5-5-5"></path>
    </g>
  </svg>
  )
}
const Leaf = () => {
  return(
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"  width={40}
    height={40}   fill="rgb(225 106 84)">
    <g id="SVGRepo_iconCarrier">
      <path d="M30.039 2.719a1.253 1.253 0 0 0-2.188-.469l-.002.002a13.5 13.5 0 0 1-6.235 4.158l-.096.026c-1.66.54-3.592.925-5.588 1.079l-.086.005A17.8 17.8 0 0 0 9.43 8.988l.114-.045c-3.466 1.876-5.78 5.485-5.78 9.633l.002.19v-.01q.014.476.068.945a11 11 0 0 0 .877 3.163l-.028-.07A30.7 30.7 0 0 0 .925 29.33l-.076.204a1.252 1.252 0 0 0 .649 1.638l.008.003c.144.064.311.102.487.102h.005a1.25 1.25 0 0 0 1.146-.75l.003-.008a30 30 0 0 1 2.96-5.455l-.066.102a11.6 11.6 0 0 0 4.37 3.593l.07.03c1.482.678 3.216 1.072 5.041 1.072h.077-.004a14.4 14.4 0 0 0 5.517-1.119l-.095.035c5.424-2.452 9.281-7.517 9.983-13.546l.008-.079c.151-1.153.237-2.486.237-3.839 0-3.061-.441-6.02-1.264-8.815l.056.22zm-1.502 12.062a14.55 14.55 0 0 1-8.373 11.642l-.09.037c-1.28.561-2.772.888-4.34.888a11 11 0 0 1-4.292-.864l.073.027a9.1 9.1 0 0 1-3.822-3.358l-.022-.037a19.04 19.04 0 0 1 13.193-5.872l.029-.001a1.25 1.25 0 1 0-.247-2.488h.005a21.83 21.83 0 0 0-14.097 5.906l.012-.011a8 8 0 0 1-.242-1.196l-.004-.042a8 8 0 0 1-.053-.885 8.34 8.34 0 0 1 4.348-7.325l.044-.022c1.6-.679 3.456-1.104 5.402-1.174l.027-.001a27.6 27.6 0 0 0 6.429-1.258l-.195.055a17.2 17.2 0 0 0 5.83-3.267l-.023.02c.404 1.735.635 3.727.635 5.773q-.002 1.826-.24 3.587l.015-.137z"></path>
    </g>
  </svg>
  )
}
const CheckMarkWide = ({width,height,fill}:NumberOneProps) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
    <g id="SVGRepo_iconCarrier">
      <path
        fill={fill}
        id="checkmark"
        fillRule="evenodd"
        d="M1224 312a12 12 0 1 1 3.32-23.526l-1.08 1.788A10 10 0 1 0 1234 300a9.8 9.8 0 0 0-.59-3.353l1.27-2.108A11.992 11.992 0 0 1 1224 312m.92-8.631a.9.9 0 0 1-.22.355.89.89 0 0 1-.72.259.91.91 0 0 1-.94-.655l-3.82-3.818a.9.9 0 0 1 1.27-1.271l3.25 3.251 7.39-10.974a1 1 0 0 1 1.38-.385 1.05 1.05 0 0 1 .36 1.417Z"
        transform="translate(-1212 -288)"
      ></path>
    </g>
  </svg>
  )
}
interface StarRainBow{
  width?:number;
  height?:number;
  fill?:string;
}
const StarRainbow = ({width,height,fill}:StarRainBow) => {
  return(
     <svg width={width ?? 35} height={height ?? 35} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier" fill={fill ?? "#F39E60"}>
      <path d="M16.946 2.847c1.408-.697 2.112-1.046 2.589-.73.475.317.408 1.09.272 2.634l-.035.4c-.038.439-.057.659.011.857.069.2.218.355.515.667l.271.284c1.048 1.097 1.571 1.646 1.399 2.208-.173.562-.927.765-2.436 1.172l-.39.105c-.43.116-.644.173-.815.308-.171.134-.28.33-.496.72l-.197.356c-.761 1.376-1.142 2.064-1.724 2.094-.583.031-.982-.616-1.779-1.909l-.206-.335c-.227-.367-.34-.55-.514-.667-.175-.116-.39-.151-.822-.221l-.392-.064c-1.518-.247-2.277-.37-2.464-.914-.188-.543.32-1.146 1.337-2.352l.262-.312c.29-.343.434-.514.497-.72s.038-.423-.012-.857l-.046-.396c-.177-1.528-.265-2.292.202-2.658s1.18-.093 2.605.455l.368.142c.405.156.608.234.821.222.214-.01.414-.11.814-.308z"></path>
      <g opacity="0.5">
        <path d="M9.045 11.32C5.99 13.27 3.27 16.797 2.09 20.032c-.383 1.05.5 1.969 1.626 1.969H4.75c0-.351.082-.787.204-1.245.125-.47.305-1.013.53-1.594a26 26 0 0 1 1.852-3.797c.763-1.28 1.67-2.528 2.665-3.466l.074-.069-.069-.022a3.1 3.1 0 0 1-.961-.488M12.02 12.217q-.48.292-.99.774c-.857.807-1.682 1.928-2.405 3.142a24 24 0 0 0-1.742 3.569c-.21.543-.372 1.033-.48 1.44-.11.418-.153.704-.153.859h2.833c0-1.124.39-3.206 1.094-5.292.517-1.53 1.233-3.153 2.155-4.44zM13.298 13.513c-.675 1.044-1.25 2.346-1.7 3.676-.678 2.007-1.015 3.915-1.015 4.812h1.289c1.126 0 2.032-.907 2.107-2.02.13-1.915.425-3.64.762-4.867a3.1 3.1 0 0 1-.782-.677 9 9 0 0 1-.66-.924"></path>
      </g>
    </g>
  </svg>
  )
}
interface CalendarIconProps{
  width?:number | string;
  height?:number | string;
}
const Calendar = ({width,height}:CalendarIconProps) =>{
  return(
     <svg
     width={width}
     height={height}
    xmlns="http://www.w3.org/2000/svg"
  
    viewBox="0 0 1024 1024"
  >
    <g id="SVGRepo_iconCarrier">
      <path fill="#FCE3C3" d="M182.067 383.79h664.916v473.911H182.067z"></path>
      <path
        fill="#300604"
        d="M846.983 857.701H170.007V401.632h676.976zM189.428 838.28h638.134V421.053H189.428z"
      ></path>
      <path
        fill="#300604"
        d="M850.483 861.201H166.507V398.132h683.977v463.069zm-676.976-7h669.977V405.132H173.507zm657.555-12.421H185.929V417.553h645.134zm-638.133-7h631.134V424.553H192.929z"
      ></path>
      <path fill="#300604" d="M179.718 273.282h657.556v138.061H179.718z"></path>
      <path
        fill="#300604"
        d="M840.774 414.844H176.219V269.782h664.556zm-657.555-7h650.556V276.782H183.219z"
      ></path>
      <path
        fill="#300604"
        d="M846.983 421.053H170.007V263.572h676.976zm-657.555-19.421h638.134V282.994H189.428z"
      ></path>
      <path
        fill="#300604"
        d="M850.483 424.553H166.507v-164.48h683.977v164.48zm-676.976-7h669.977v-150.48H173.507zm657.555-12.421H185.929V279.494h645.134zm-638.133-7h631.134V286.494H192.929z"
      ></path>
      <path fill="#ED8F27" d="M672.215 190.225h63.426v162.87h-63.426z"></path>
      <path
        fill="#300604"
        d="M745.351 362.806h-82.847V180.514h82.847zm-63.426-19.421h44.005v-143.45h-44.005z"
      ></path>
      <path fill="#ED8F27" d="M281.351 190.225h63.426v162.87h-63.426z"></path>
      <path
        fill="#300604"
        d="M354.487 362.806H271.64V180.514h82.847zm-63.426-19.421h44.005v-143.45h-44.005z"
      ></path>
      <path fill="#B12800" d="M688.071 468.427h66.597v66.597h-66.597z"></path>
      <path
        fill="#228E9D"
        d="M688.071 596.369h66.597v66.597h-66.597zm0 127.941h66.597v66.598h-66.597zM546.156 468.427h66.597v66.597h-66.597z"
      ></path>
      <path fill="#B12800" d="M546.156 596.369h66.597v66.597h-66.597z"></path>
      <path
        fill="#228E9D"
        d="M546.156 724.31h66.597v66.598h-66.597zM404.239 468.427h66.598v66.597h-66.598z"
      ></path>
      <path fill="#B12800" d="M404.239 596.369h66.598v66.597h-66.598z"></path>
      <path
        fill="#228E9D"
        d="M404.239 724.31h66.598v66.598h-66.598zM262.323 596.369h66.598v66.597h-66.598z"
      ></path>
      <path fill="#B12800" d="M262.323 724.31h66.598v66.598h-66.598z"></path>
    </g>
  </svg>
  )
}
interface ArrowRightProps{
  width?:number;
  height?:number;
  fill?:string;
  className?:string;
  onClick?:()=>void;
}
const ArrowRight = ({width,height,fill,className,onClick}:ArrowRightProps) => {
  return(
     <svg onClick={onClick} className={className} width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 12h14m0 0-6-6m6 6-6 6"
    ></path>
  </svg>
  )
}
const ArrowLeft = ({width,height,fill,className,onClick}:ArrowRightProps) => {
  return(
    <svg onClick={onClick} className={className} width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 12h14M5 12l6-6m-6 6 6 6"
    />
  </svg>
  );
}
const GraduationCap = () => {
  return(
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30} height={30}
    className="iconify iconify--noto"
    viewBox="0 0 128 128"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#424242"
        d="M99.06 91.42S83.95 105.6 63.97 105.6 28.89 91.42 28.89 91.42s-2.81-13.49 4.45-36.78c3.83-12.28 58.33-13.53 62.6-2.79 7.26 18.23 3.12 39.57 3.12 39.57"
      ></path>
      <path
        fill="#212121"
        d="m28.89 91.42 4.79 3.84s-.04-7.6 2.31-14.69c.88-2.65 4.02-3.76 6.38-2.27l18.29 11.47a6.39 6.39 0 0 0 6.7.05c8.74-5.3 31.54-19.17 32.58-20.02 0 0 0-1.71-.43-3.89L28.63 66z"
      ></path>
      <path
        fill="#424242"
        d="m122.81 52.03-56.8 33.83c-1.24.74-2.79.74-4.04 0L5.19 52.03c-1.58-.94-1.58-3.23 0-4.17l56.8-33.83c1.24-.74 2.79-.74 4.04 0l56.8 33.83c1.57.94 1.57 3.23-.02 4.17"
      ></path>
      <path
        fill="#9e9e9e"
        d="M64.04 83.38c-.01 0-.03.01-.04.01-.16 0-.32-.04-.46-.13L4.18 49.04s-.29.55 0 1.54c.3.99.76 1.31 1.01 1.46l56.8 33.83c.62.37 1.32.56 2.02.56h.04v-3.05z"
      ></path>
      <path
        fill="#616161"
        d="M64 83.38c.01 0 .03.01.04.01.16 0 .32-.04.46-.13l59.36-34.22s.29.55 0 1.54c-.3.99-.76 1.31-1.01 1.46l-56.8 33.83c-.62.37-1.32.56-2.02.56h-.04v-3.05z"
      ></path>
      <path
        fill="#424242"
        d="m35.45 70.06.32-2.81S60.28 53.92 62.7 52.52s4.96-2.96 6.09-4.21c2-2.2.56-3.58.56-3.58s-1.58 2.56-5.35 2.11c-2.16-.26-4.97-2.01-5.44-2.83s-27.67 19.9-27.67 19.9l-.19 3.33z"
      ></path>
      <path
        fill="#e2a610"
        d="M69.35 44.74c-2.62 3.66-7.06 2.06-7.06 2.06s-13.91 6.67-14.43 5.66 11.49-7.19 11.49-7.19-.67-2.46-.6-3.51c0 0-21.72 13.82-29.87 18.47-4.27 2.44-5.18 4.74-5.17 7.98 0 1.42.02 6.03.04 8.78 0 .51-.22.99-.61 1.31a5.16 5.16 0 0 0-1.89 3.99c0 1.53.67 2.9 1.73 3.85.57.51.45 1.61.5 2.32.1 1.36 0 1.98-.56 3.24-.55 1.23-1.06 2.49-1.41 3.79-.27 1-.45 2.03-.63 3.05-1.19 6.83-1.73 14.13-4.88 20.41a.993.993 0 0 0 .45 1.34 1.007 1.007 0 0 0 1.35-.44c1.64-3.27 2.49-6.85 3.19-10.4-.04 3.21-.06 6.45-.17 9.95-.02.68-.07 2.05.55 2.35 2.33 1.13 2.33-2.35 2.33-2.35s.03 3.13 3.2 3.13 3.4-3.13 3.4-3.13.23 2.87 1.86 2.73c.66-.06 1.53-.46 1.22-3.89-.31-3.42-1.08-15.68-1.41-19.56-.46-5.37-2.22-8.56-2.58-10.46-.13-.72-.14-1.47.43-1.94a5.165 5.165 0 0 0 .13-7.88 1.71 1.71 0 0 1-.58-1.42c.19-2.59.4-6.35.57-7.22.74-3.91 2.67-4.61 4.65-5.77 1.98-1.17 30.66-14.19 32.33-15.3 3.09-2.07 2.43-3.95 2.43-3.95"
      ></path>
      <path
        fill="#ffca28"
        d="M69.35 44.74c-2.47 3.49-7.6 1.93-7.6 1.93s-13.11 5.81-12.24 4.76c.86-1.05 9.84-6.16 9.84-6.16s-.67-2.46-.6-3.51c0 0-22.1 12.77-30.67 18.91-2.21 1.59-4.95 4.19-2.72 6.78 1.03 1.19 3.02 1.44 4.29.5.77-.56 1.37-1.38 2.05-2.03.84-.82 1.86-1.34 2.86-1.93 1.98-1.17 30.66-14.19 32.33-15.3 3.12-2.07 2.46-3.95 2.46-3.95"
      ></path>
      <path
        fill="#9e740b"
        d="M26.11 91.86c-1.32 0-2.21-.11-3.02-.3a.62.62 0 0 1-.48-.65l.26-3.82c.03-.39.4-.66.78-.55.9.26 2.7.52 5.64-.1.36-.08.72.17.76.54l.4 3.8c.03.31-.17.6-.47.67-1.53.35-2.64.41-3.87.41"
      ></path>
      <path
        fill="#616161"
        d="M99.06 91.42s1.77-9.24 1.06-19.07c-.12-1.66-1.14-3.09-1.93 2.72-.45 3.33-1.43 13.3-3.1 19.53 2.55-1.84 3.97-3.18 3.97-3.18M65.73 36.79c.73.23 1.4.79 1.59 1.54.25 1-.38 2-1.06 2.78-1.33 1.53-3.16 2.87-5.19 2.8-.67-.02-1.39-.24-1.8-.77-.29-.37-.39-.85-.42-1.32-.18-3.43 3.7-6.03 6.88-5.03"
      ></path>
    </g>
  </svg>
  )
}
const Exam = () => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
    width={30} height={30}
  >
    <g id="SVGRepo_iconCarrier">
      <path fill="#CFDCE5" d="M0 8.198h370.957v495.607H0z"></path>
      <path
        fill="#4EBFED"
        d="m432.203 93.909 39.898-85.711 39.898 85.711v385.139c0 13.673-11.083 24.756-24.756 24.756h-30.286c-13.673 0-24.756-11.083-24.756-24.756V93.909z"
      ></path>
      <path
        fill="#FF6F52"
        d="M511.996 438.44v40.606c0 13.671-11.086 24.757-24.757 24.757h-30.287c-13.671 0-24.744-11.086-24.744-24.757V438.44z"
      ></path>
      <path fill="#97E1F7" d="M473.027 93.909h14.845v344.529h-14.845z"></path>
      <path
        fill="#3BA4BC"
        d="M432.203 479.048c0 13.673 11.083 24.756 24.756 24.756h7.55c-6.855 0-12.414-11.083-12.414-24.756V93.909l20.007-85.711-39.898 85.711z"
      ></path>
      <path fill="#FCD577" d="M511.996 93.91h-79.788l39.888-85.715z"></path>
      <path
        fill="#E25749"
        d="M464.512 503.802h-7.559c-13.671 0-24.744-11.086-24.744-24.757V438.44h19.882v40.606c-.001 13.671 5.566 24.756 12.421 24.756"
      ></path>
      <path fill="#EAC36E" d="M452.09 93.91h-19.882l39.888-85.715z"></path>
      <path fill="#FCD577" d="M432.199 429.156H512v18.558h-79.801z"></path>
      <g fill="#415E72">
        <path d="M76.918 72.858h217.12v18.558H76.918zM268.279 168.287h56.291v18.558h-56.291zM46.393 168.287h209.511v18.558H46.393zM46.393 264.395H324.57v18.558H46.393zM121.681 216.341h202.892v18.558H121.681zM46.393 216.341h62.912v18.558H46.393zM46.393 408.556H324.57v18.558H46.393zM244.154 360.502h80.416v18.558h-80.416zM46.393 360.502h185.385v18.558H46.393z"></path>
      </g>
    </g>
  </svg>
  )
}
const Lecture = () => {
  return(
     <svg
     width={30}
     height={30}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#FFDC64"
        d="M203.034 119.172h-52.966c-9.75 0-17.655 7.904-17.655 17.655v17.655h88.276v-17.655c.001-9.751-7.904-17.655-17.655-17.655"
      ></path>
      <g fill="#F5DCB4">
        <path d="M503.172 454.621H8.828c-4.879 0-8.828-3.953-8.828-8.828s3.948-8.828 8.828-8.828h494.345c4.879 0 8.828 3.953 8.828 8.828s-3.949 8.828-8.829 8.828M423.724 233.931H88.276a8.826 8.826 0 0 1-8.828-8.828 8.826 8.826 0 0 1 8.828-8.828h335.448a8.826 8.826 0 0 1 8.828 8.828 8.826 8.826 0 0 1-8.828 8.828"></path>
      </g>
      <path
        fill="#D5DCED"
        d="M220.69 216.276h-88.276a8.83 8.83 0 0 1-8.828-8.828v-52.966a8.83 8.83 0 0 1 8.828-8.828h88.276a8.83 8.83 0 0 1 8.828 8.828v52.966a8.83 8.83 0 0 1-8.828 8.828"
      ></path>
      <circle cx="176.552" cy="180.966" r="11.034" fill="#FFF"></circle>
      <path
        fill="#D29B6E"
        d="M176.552 136.828c-7.313 0-13.241-5.929-13.241-13.241v-13.241h26.483v13.241c-.001 7.312-5.93 13.241-13.242 13.241"
      ></path>
      <path
        fill="#F0C087"
        d="M178.067 119.172h-3.029c-4.682 0-9.173-1.86-12.484-5.171l-7.313-7.313a17.65 17.65 0 0 1-5.171-12.484v-19.17c0-9.751 7.904-17.655 17.655-17.655h17.655c9.751 0 17.655 7.904 17.655 17.655v19.17c0 4.682-1.86 9.173-5.171 12.484l-7.313 7.313a17.66 17.66 0 0 1-12.484 5.171"
      ></path>
      <g fill="#694B4B">
        <path d="M185.379 57.379h-17.655c-9.751 0-17.655 7.904-17.655 17.655v8.828s26.483 0 52.966-8.828c-.001-9.751-7.905-17.655-17.656-17.655M308.966 83.862h52.966V128h-52.966z"></path>
      </g>
      <path
        fill="#00C3FF"
        d="M353.103 119.172h-35.31c-9.751 0-17.655 7.904-17.655 17.655v17.655h70.621v-17.655c0-9.751-7.904-17.655-17.656-17.655"
      ></path>
      <path
        fill="#D5DCED"
        d="M379.586 216.276H291.31a8.83 8.83 0 0 1-8.828-8.828v-52.966a8.83 8.83 0 0 1 8.828-8.828h88.276a8.83 8.83 0 0 1 8.828 8.828v52.966a8.83 8.83 0 0 1-8.828 8.828"
      ></path>
      <circle cx="335.448" cy="180.966" r="11.034" fill="#FFF"></circle>
      <path
        fill="#D29B6E"
        d="M335.448 136.828c-7.313 0-13.241-5.929-13.241-13.241v-13.241h26.483v13.241c0 7.312-5.929 13.241-13.242 13.241"
      ></path>
      <path
        fill="#F0C087"
        d="m323.305 115.857-9.167-9.167a17.65 17.65 0 0 1-5.171-12.484v-19.17c0-9.751 7.904-17.655 17.655-17.655h17.655c9.751 0 17.655 7.904 17.655 17.655v19.17c0 4.682-1.86 9.173-5.171 12.484l-9.167 9.167c-6.709 6.706-17.582 6.706-24.289 0"
      ></path>
      <g fill="#694B4B">
        <path d="M344.276 57.379h-17.655c-9.751 0-17.655 7.904-17.655 17.655v8.828s26.483 0 52.966-8.828c-.001-9.751-7.905-17.655-17.656-17.655M229.517 304.552h52.966v44.138h-52.966z"></path>
      </g>
      <path
        fill="#FF5050"
        d="M273.655 339.862h-35.31c-9.751 0-17.655 7.904-17.655 17.655v17.655h70.621v-17.655c-.001-9.751-7.905-17.655-17.656-17.655"
      ></path>
      <path
        fill="#D5DCED"
        d="M300.138 436.966h-88.276a8.83 8.83 0 0 1-8.828-8.828v-52.966a8.83 8.83 0 0 1 8.828-8.828h88.276a8.83 8.83 0 0 1 8.828 8.828v52.966a8.83 8.83 0 0 1-8.828 8.828"
      ></path>
      <circle cx="256" cy="401.655" r="11.034" fill="#FFF"></circle>
      <path
        fill="#D29B6E"
        d="M256 357.517c-7.313 0-13.241-5.929-13.241-13.241v-13.241h26.483v13.241c-.001 7.312-5.929 13.241-13.242 13.241"
      ></path>
      <path
        fill="#F0C087"
        d="m243.857 336.546-9.167-9.167a17.65 17.65 0 0 1-5.171-12.484v-19.17c0-9.751 7.904-17.655 17.655-17.655h17.655c9.751 0 17.655 7.904 17.655 17.655v19.17c0 4.682-1.86 9.173-5.171 12.484l-9.167 9.167c-6.709 6.707-17.583 6.707-24.289 0"
      ></path>
      <path
        fill="#694B4B"
        d="M264.828 278.069h-17.655c-9.751 0-17.655 7.904-17.655 17.655v8.828s26.483 0 52.966-8.828c-.001-9.751-7.905-17.655-17.656-17.655"
      ></path>
      <path
        fill="#5B5D6E"
        d="M123.586 339.862H70.621c-9.75 0-17.655 7.904-17.655 17.655v17.655h88.276v-17.655c-.001-9.751-7.906-17.655-17.656-17.655"
      ></path>
      <path
        fill="#D5DCED"
        d="M141.241 436.966H52.966a8.83 8.83 0 0 1-8.828-8.828v-52.966a8.83 8.83 0 0 1 8.828-8.828h88.276a8.83 8.83 0 0 1 8.828 8.828v52.966a8.83 8.83 0 0 1-8.829 8.828"
      ></path>
      <circle cx="97.103" cy="401.655" r="11.034" fill="#FFF"></circle>
      <path
        fill="#D29B6E"
        d="M97.103 357.517c-7.313 0-13.241-5.929-13.241-13.241v-13.241h26.483v13.241c0 7.312-5.929 13.241-13.242 13.241"
      ></path>
      <path
        fill="#F0C087"
        d="M98.618 339.862H95.59c-4.682 0-9.173-1.86-12.484-5.171l-7.313-7.313a17.65 17.65 0 0 1-5.171-12.484v-19.17c0-9.751 7.904-17.655 17.655-17.655h17.655c9.751 0 17.655 7.904 17.655 17.655v19.17c0 4.682-1.86 9.173-5.171 12.484l-7.313 7.313a17.66 17.66 0 0 1-12.485 5.171"
      ></path>
      <path
        fill="#694B4B"
        d="M105.931 278.069H88.276c-9.751 0-17.655 7.904-17.655 17.655v8.828s26.483 0 52.966-8.828c-.001-9.751-7.905-17.655-17.656-17.655"
      ></path>
      <path
        fill="#A0FFB4"
        d="M441.379 339.862h-52.966c-9.75 0-17.655 7.904-17.655 17.655v17.655h88.276v-17.655c0-9.751-7.905-17.655-17.655-17.655"
      ></path>
      <path
        fill="#D5DCED"
        d="M459.034 436.966h-88.276a8.83 8.83 0 0 1-8.828-8.828v-52.966a8.83 8.83 0 0 1 8.828-8.828h88.276a8.83 8.83 0 0 1 8.828 8.828v52.966a8.83 8.83 0 0 1-8.828 8.828"
      ></path>
      <circle cx="414.897" cy="401.655" r="11.034" fill="#FFF"></circle>
      <path
        fill="#D29B6E"
        d="M414.897 357.517c-7.313 0-13.241-5.929-13.241-13.241v-13.241h26.483v13.241c-.001 7.312-5.93 13.241-13.242 13.241"
      ></path>
      <path
        fill="#F0C087"
        d="M416.412 339.862h-3.029c-4.682 0-9.173-1.86-12.484-5.171l-7.313-7.313a17.65 17.65 0 0 1-5.171-12.484v-19.17c0-9.751 7.904-17.655 17.655-17.655h17.655c9.751 0 17.655 7.904 17.655 17.655v19.17c0 4.682-1.86 9.173-5.171 12.484l-7.313 7.313a17.66 17.66 0 0 1-12.484 5.171"
      ></path>
      <path
        fill="#694B4B"
        d="M423.724 278.069h-17.655c-9.751 0-17.655 7.904-17.655 17.655v8.828s26.483 0 52.966-8.828c-.001-9.751-7.905-17.655-17.656-17.655"
      ></path>
    </g>
  </svg>
  )
}
const Cash = () => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width="50"
    height="50"
    fill="#000"
    version="1.1"
    viewBox="0 0 503.467 503.467"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#E4F2DE"
        d="M499.2 38.4v221.867c0 18.773-15.36 34.133-34.133 34.133H38.4c-18.773 0-34.133-15.36-34.133-34.133V38.4c0-18.773 15.36-34.133 34.133-34.133h426.667c18.773 0 34.133 15.36 34.133 34.133"
      ></path>
      <path
        fill="#49A010"
        d="M362.667 345.6v25.6s0 25.6-17.067 42.667-42.667 17.067-42.667 17.067h-25.6v-25.6s0-25.6 17.067-42.667 42.667-17.067 42.667-17.067zm-153.6 110.933v25.6h-25.6s-25.6 0-42.667-17.067C123.733 448 123.733 422.4 123.733 422.4v-25.6h25.6s25.6 0 42.667 17.067c17.067 17.066 17.067 42.666 17.067 42.666"
      ></path>
      <path
        fill="#51565F"
        d="M243.2 503.467c-2.56 0-4.267-1.707-4.267-4.267V298.667H38.4c-21.333 0-38.4-17.067-38.4-38.4V38.4C0 17.067 17.067 0 38.4 0h426.667c21.333 0 38.4 17.067 38.4 38.4v221.867c0 21.333-17.067 38.4-38.4 38.4H277.333c-2.56 0-4.267-1.707-4.267-4.267s1.707-4.267 4.267-4.267h187.733c16.213 0 29.867-13.653 29.867-29.867V38.4c0-16.213-13.653-29.867-29.867-29.867H38.4C22.187 8.533 8.533 22.187 8.533 38.4v221.867c0 16.213 13.653 29.867 29.867 29.867h204.8c2.56 0 4.267 1.707 4.267 4.267v204.8c0 2.559-1.707 4.266-4.267 4.266M209.067 486.4h-25.6c-.853 0-27.307 0-46.08-17.92s-17.92-44.373-17.92-46.08v-25.6c0-2.56 1.707-4.267 4.267-4.267h25.6c.853 0 27.307 0 46.08 17.92s17.92 44.373 17.92 46.08v25.6c-.001 2.56-1.707 4.267-4.267 4.267M128 401.067V422.4s0 23.893 16.213 39.253c15.36 15.36 39.253 16.213 39.253 16.213H204.8v-21.333s0-23.893-16.213-39.253c-15.36-15.36-39.253-16.213-39.253-16.213zM302.933 435.2h-25.6c-2.56 0-4.267-1.707-4.267-4.267v-25.6c0-.853 0-27.307 17.92-46.08s44.373-17.92 46.08-17.92h25.6c2.56 0 4.267 1.707 4.267 4.267v25.6c0 .853 0 27.307-17.92 46.08s-45.226 17.92-46.08 17.92m-21.333-8.533h21.333s23.893 0 39.253-16.213c15.36-15.36 16.213-39.253 16.213-39.253v-21.333h-21.333s-23.893 0-39.253 16.213c-15.36 15.36-16.213 39.253-16.213 39.253zm132.267-162.134H89.6c-2.56 0-4.267-1.707-4.267-4.267 0-25.6-21.333-46.933-46.933-46.933-2.56 0-4.267-1.707-4.267-4.267V89.6c0-2.56 1.707-4.267 4.267-4.267C64 85.333 85.333 64 85.333 38.4c0-2.56 1.707-4.267 4.267-4.267h324.267c2.56 0 4.267 1.707 4.267 4.267 0 25.6 21.333 46.933 46.933 46.933 2.56 0 4.267 1.707 4.267 4.267v119.467c0 2.56-1.707 4.267-4.267 4.267-25.6 0-46.933 21.333-46.933 46.933-.001 2.56-1.707 4.266-4.267 4.266m-320-8.533H409.6c1.707-27.307 23.893-48.64 51.2-51.2V93.867c-27.307-1.707-48.64-23.893-51.2-51.2H93.867c-1.707 27.307-23.893 48.64-51.2 51.2V204.8c27.306 2.56 48.64 23.893 51.2 51.2m157.866-42.667c-2.56 0-4.267-1.707-4.267-4.267V204.8c-14.507-1.707-25.6-14.507-25.6-29.867 0-2.56 1.707-4.267 4.267-4.267s4.267 1.707 4.267 4.267c0 11.947 9.387 21.333 21.333 21.333 11.947 0 21.333-9.387 21.333-21.333 0-11.947-9.387-21.333-21.333-21.333-16.213 0-29.867-13.653-29.867-29.867 0-15.36 11.093-27.307 25.6-29.867V89.6c0-2.56 1.707-4.267 4.267-4.267S256 87.04 256 89.6v4.267c14.507 1.707 25.6 14.507 25.6 29.867 0 2.56-1.707 4.267-4.267 4.267s-4.267-1.707-4.267-4.267c0-11.947-9.387-21.333-21.333-21.333-11.947 0-21.333 9.387-21.333 21.333 0 11.947 9.387 21.333 21.333 21.333 16.213 0 29.867 13.653 29.867 29.867 0 15.36-11.093 27.307-25.6 29.867v4.267c0 2.559-1.707 4.265-4.267 4.265"
      ></path>
    </g>
  </svg>
  )
}
const AlternativeLeaf = () => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width="35"
    height="35"
    fill="#000"
    version="1.1"
    viewBox="0 0 504.125 504.125"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#3A7F0D"
        d="M339.772 0s44.536 108.954-146.337 182.138C89.719 221.893 10.059 323.789 105.173 481.193c7.877-70.357 41.653-225.485 186.888-260.884 0 0-135.176 50.546-147.117 279.347 69.459 9.752 232.361 16.305 280.726-125.062C489.536 187.817 339.772 0 339.772 0"
      ></path>
      <path
        fill="#49A010"
        d="M145.007 498.704c147.456-58.849 254.748-196.71 269.556-361.283C384.418 56.107 339.772 0 339.772 0s44.536 108.954-146.337 182.138C89.719 221.893 10.059 323.789 105.173 481.193c7.877-70.357 41.653-225.485 186.888-260.884-.008.001-134.782 50.421-147.054 278.395"
      ></path>
      <circle cx="90.459" cy="171.985" r="13.785" fill="#3A7F0D"></circle>
      <g fill="#49A010">
        <circle cx="133.782" cy="158.2" r="9.846"></circle>
        <circle cx="124.921" cy="64.662" r="24.615"></circle>
        <circle cx="200.736" cy="120.785" r="7.877"></circle>
        <circle cx="266.713" cy="76.477" r="22.646"></circle>
      </g>
    </g>
  </svg>
  )
}
const Gift = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width={40}>
    <g id="SVGRepo_iconCarrier">
      <path
        fill="url(#paint0_linear_103_1312)"
        fillRule="evenodd"
        d="M9.49.55A1.476 1.476 0 0 0 7.313.416L5.529 2.162a1.403 1.403 0 0 0 .136 2.129l7.956 6.052 1.829-1.789 1.829 1.79 7.956-6.053c.69-.526.754-1.524.135-2.13L23.586.418a1.476 1.476 0 0 0-2.177.132l-5.96 7.495z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint1_linear_103_1312)"
        d="M30.546 7.814H1.454C.65 7.814 0 8.45 0 9.236v4.268c0 .786.651 1.423 1.455 1.423h29.09c.804 0 1.455-.637 1.455-1.422V9.236c0-.785-.651-1.422-1.454-1.422"
      ></path>
      <path
        fill="url(#paint2_linear_103_1312)"
        d="M2.909 14.927H29.09v14.228c0 1.571-1.303 2.845-2.91 2.845H5.818c-1.607 0-2.91-1.274-2.91-2.846z"
      ></path>
      <path
        fill="#fff"
        d="M18.91 7.814H13.09V32h5.819z"
        style={{ mixBlendMode: "soft-light" }}
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_103_1312"
          x1="15.45"
          x2="15.45"
          y1="0"
          y2="10.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE9B13"></stop>
          <stop offset="1" stopColor="#FE9B13"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_103_1312"
          x1="16"
          x2="16"
          y1="7.814"
          y2="14.927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA9644"></stop>
          <stop offset="1" stopColor="#FE6E2C"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_103_1312"
          x1="26.915"
          x2="14.404"
          y1="16.351"
          y2="37.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F75D00"></stop>
          <stop offset="1" stopColor="#F86710"></stop>
        </linearGradient>
      </defs>
    </g>
  </svg>
  )
}
const ArrowUp = () => {
  return(
     <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <path
    fill="#E16A54"
      id="SVGRepo_iconCarrier"
      d="m264.8 604.7 61.8 61.8L512 481.1l185.4 185.4 61.8-61.8L512 357.5z"
    ></path>
  </svg>
  )
}
const ArrowDown = () => {
  return(
    <svg width={25} height={25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <path
    fill="#E16A54"
      id="SVGRepo_iconCarrier"
      d="M759.2 419.8 697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z"
    ></path>
  </svg>
  )
}
interface LeafGrowProps{
  width?:number;
  height?:number;
  fill?:string;
}
const LeafGrow = ({width,height,fill}:LeafGrowProps) => {
  return(
      <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={width ?? "20"}
    height={height ?? "20"}
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#B6E892"
        d="M454.664 28.923a23.28 23.28 0 0 0-17.487-20.008c-4.107-1.026-101.28-24.408-164.721 39.035a139.3 139.3 0 0 0-16.454 19.822q-.003-.001-.002-.002a139.7 139.7 0 0 0-16.455-19.821c-36.417-36.42-84.086-44.063-117.662-44.063-26.633 0-46.237 4.822-47.057 5.028a23.27 23.27 0 0 0-17.487 20.008c-.123 1.105-2.968 27.39-.047 59.532 4.147 45.608 17.481 79.965 39.633 102.116 36.42 36.419 84.089 44.063 117.665 44.063 6.527 0 12.631-.292 18.139-.731v43.442c7.606-1.283 15.385-1.946 23.273-1.946s15.667.662 23.273 1.946v-43.421c5.5.436 11.605.725 18.157.725 34.576 0 81.569-8.001 117.647-44.079 22.153-22.151 35.488-56.509 39.633-102.116 2.921-32.139.074-58.428-.048-59.53"
      ></path>
      <path
        fill="#A78966"
        d="M376.996 345.297a139.6 139.6 0 0 0-120.997-69.896 139.604 139.604 0 0 0-120.997 69.896C60.144 347.75 0 409.412 0 484.856c0 12.854 10.42 23.273 23.273 23.273h465.454c12.853 0 23.273-10.418 23.273-23.273 0-75.444-60.145-137.106-135.004-139.559"
      ></path>
      <path
        fill="#7ED63E"
        d="M256 67.772a139.7 139.7 0 0 0-16.455-19.821c-36.417-36.42-84.086-44.063-117.662-44.063-26.633 0-46.237 4.822-47.057 5.028a23.27 23.27 0 0 0-17.487 20.008c-.123 1.105-2.968 27.39-.047 59.532 4.147 45.608 17.481 79.965 39.633 102.116 36.42 36.419 84.089 44.063 117.665 44.063 6.527 0 12.631-.292 18.139-.731v43.442a140 140 0 0 1 23.273-1.946V67.772z"
      ></path>
      <path
        fill="#806749"
        d="M232.727 277.347a139.6 139.6 0 0 0-97.724 67.95C60.144 347.75 0 409.412 0 484.856c0 12.854 10.42 23.273 23.273 23.273H256V275.402c-7.888 0-15.667.662-23.273 1.945"
      ></path>
    </g>
  </svg>
  )
}
interface CompassProps{
  width?:number;
  height?:number;
}
const Compass = ({width,height}:CompassProps) => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? '20'}
    height={height ?? '20'}
    className="iconify iconify--noto"
    viewBox="0 0 128 128"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#e2a610"
        d="M120.27 7.69C117.89 5.31 114.72 4 111.36 4s-6.53 1.31-8.91 3.69c-4.91 4.92-4.91 12.92 0 17.84 2.38 2.38 5.55 3.69 8.91 3.69 3.37 0 6.53-1.31 8.92-3.69 4.91-4.92 4.91-12.92-.01-17.84m-13.89 3.94c1.33-1.33 3.1-2.06 4.97-2.06s3.65.73 4.98 2.06c2.75 2.75 2.75 7.22 0 9.96a7 7 0 0 1-4.98 2.06c-1.88 0-3.65-.73-4.97-2.06-2.74-2.74-2.74-7.21 0-9.96"
      ></path>
      <path
        fill="#ffca28"
        d="m105.51 30.95-8.47-8.48 6.04-6.05a3.44 3.44 0 0 1 4.86 0l3.62 3.62a3.43 3.43 0 0 1 0 4.85z"
      ></path>
      <path
        fill="#e2a610"
        d="M107.69 28.76s1.33-2.67-2.24-6.24-6.27-2.2-6.27-2.2l-2.14 2.15 8.47 8.48z"
      ></path>
      <ellipse
        cx="62.37"
        cy="65.63"
        fill="#ffca28"
        rx="58.33"
        ry="58.37"
      ></ellipse>
      <ellipse
        cx="62.37"
        cy="65.63"
        fill="#fff"
        rx="47.29"
        ry="47.32"
      ></ellipse>
      <path
        fill="#e0c3ab"
        d="m68.78 72.05-6.41 27.71-6.41-27.71-27.7-6.42 27.7-6.41 6.41-27.72 6.41 27.72 27.7 6.41z"
      ></path>
      <path
        fill="#b2947c"
        d="m71.43 65.63 15.06 24.14L62.37 74.7 38.25 89.77l15.06-24.14L38.25 41.5l24.12 15.06L86.49 41.5z"
      ></path>
      <path
        fill="#212121"
        d="M50.45 86.94s12.82-9.09 17.68-13.95C73 68.14 83.26 53.87 83.26 53.87c2.75-3.05 5.84-10.76 6.7-13 .09-.24-.14-.48-.38-.39-1.96.75-8.17 3.2-12.5 5.96-5.41 3.46-15.09 11.37-19.6 15.88s-10.37 13.2-13.7 17.93c-2.78 3.96-6.26 11.32-7.31 13.61-.12.25.14.51.39.4 2.36-.99 10.01-4.36 13.59-7.32"
        opacity="0.32"
      ></path>
      <path
        fill="#f44336"
        d="M82.66 52.46c2.86-3.65 5.57-10.84 6.37-13.07.1-.27-.16-.53-.44-.44-2.23.8-9.41 3.52-13.06 6.38-4.35 3.41-18.82 15.3-18.82 15.3l10.65 10.66c.01 0 11.89-14.48 15.3-18.83"
      ></path>
      <path
        fill="#2f7889"
        d="M41.41 79.48c-2.86 3.65-5.57 10.84-6.37 13.07-.1.27.16.53.44.44 2.23-.8 9.41-3.52 13.06-6.38 4.35-3.41 18.82-15.3 18.82-15.3L56.7 60.65S44.82 75.12 41.41 79.48"
      ></path>
      <ellipse
        cx="62.03"
        cy="65.98"
        fill="#94d1e0"
        rx="7.56"
        ry="7.57"
      ></ellipse>
      <path
        fill="#f44336"
        d="M90.46 37.52a3.44 3.44 0 0 1 0-4.86l3.56-3.56 4.86 4.86-3.55 3.56a3.434 3.434 0 0 1-4.87 0"
      ></path>
      <path
        fill="#b2947c"
        d="M34.28 93.74a3.44 3.44 0 0 1 0 4.86l-3.56 3.56-4.86-4.86 3.55-3.56a3.45 3.45 0 0 1 4.87 0"
      ></path>
      <g fill="#e0c3ab">
        <path d="M102.1 65.63c0-1.9 1.54-3.44 3.44-3.44h5.02v6.88h-5.02a3.44 3.44 0 0 1-3.44-3.44M22.65 65.63c0 1.9-1.54 3.44-3.44 3.44h-5.02v-6.88h5.02c1.9 0 3.44 1.54 3.44 3.44"></path>
      </g>
      <g fill="#b2947c">
        <path d="M90.46 93.74a3.44 3.44 0 0 1 4.86 0l3.55 3.56-4.86 4.86-3.56-3.56a3.45 3.45 0 0 1 .01-4.86M34.28 37.52a3.44 3.44 0 0 1-4.86 0l-3.55-3.56 4.86-4.86 3.56 3.56a3.45 3.45 0 0 1-.01 4.86"></path>
      </g>
      <g fill="#e0c3ab">
        <path d="M62.37 105.38c1.9 0 3.44 1.54 3.44 3.44v5.03h-6.87v-5.03a3.425 3.425 0 0 1 3.43-3.44M62.37 25.88a3.44 3.44 0 0 1-3.44-3.44v-5.03h6.87v5.03c.01 1.9-1.53 3.44-3.43 3.44"></path>
      </g>
      <ellipse
        cx="62.37"
        cy="65.63"
        fill="none"
        stroke="#e2a610"
        strokeMiterlimit="10"
        strokeWidth="3"
        rx="47.29"
        ry="47.32"
      ></ellipse>
      <path
        fill="#fff59d"
        d="M8.72 64.92S6.6 54.18 12.25 40.88C20.59 21.26 38.6 10.46 57.97 9.62c14.53-.63 22.91 4.16 22.91 4.16s-11.82-.97-19.97-.61c-19.66.87-33.32 9.84-42.68 25.18-7.7 12.64-9.51 26.57-9.51 26.57"
      ></path>
    </g>
  </svg>
  )
}
const Bullseye = () => {
  return(
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    className="iconify iconify--noto"
    viewBox="0 0 128 128"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#ff2a23"
        d="M63.04 7.57C36.72 6.97 7.69 28.8 8.25 64.16c.49 31.09 23.85 54.62 54.12 55.11S119.46 99.75 119.62 64c.17-36.03-27.63-55.77-56.58-56.43"
      ></path>
      <path
        fill="#fffdfe"
        d="M63.12 20.19c-20.88.71-41.95 16.29-42.44 43.76s23.52 42.77 42.44 42.77c24.02 0 44.09-18.92 43.59-44.09-.49-25.16-19.41-43.26-43.59-42.44"
      ></path>
      <path
        fill="#ff2a23"
        d="M63.61 30.89c-18.92-.43-32.9 16.29-33.07 32.24-.16 16.29 10.03 32.9 32.74 33.72S96.67 79.58 97 64.28c.34-15.3-11.84-32.9-33.39-33.39"
      ></path>
      <path
        fill="#fff"
        d="M41.98 63.73c-.16 14.31 10.03 22.54 22.37 22.54 11.21 0 22.21-7.07 22.21-22.04 0-13.49-10.2-21.55-21.55-22.04-11.35-.5-22.87 7.73-23.03 21.54"
      ></path>
      <path
        fill="#fb2b22"
        d="M52.1 63.62c-.61 8.53 6.33 12.61 12.58 12.61 5.92 0 11.76-3.89 11.93-11.79.15-7.42-5.67-11.95-11.93-12.17-6.46-.22-12.09 4.42-12.58 11.35"
      ></path>
      <path
        fill="#cc1935"
        d="m66.74 64.29-3.35 1.86 6.39 9.09s4.94.38 6.08-.91-.15-5.09-.15-5.09z"
      ></path>
      <path
        fill="#acb1b5"
        d="M87.42 54.41c-.9-1.86-1.82-3.35-4.26-2.89-2.43.46-6.92 3.04-7.76 4.26-.77 1.12-1.52 2.51-1.52 2.51s-8.6 4.7-9.96 5.47c-2.13 1.22-.66 3.7.84 3.42 2.05-.38 11.21-4.11 11.21-4.11s1.94.46 3.08.46 7.64-3.21 8.52-3.8c1.45-.99.76-3.42-.15-5.32"
      ></path>
      <path
        fill="#c8c8c8"
        d="M75.68 69.22s-.48 1.7-2.23 3.46c-1.82 1.82-3.69 2.54-3.69 2.54l5.77 8.46s4.29.31 7.41-2.73 1.76-7.02 1.76-7.02z"
      ></path>
      <path
        fill="#cc1935"
        d="m81.4 92.57-5.88-8.9s.98-.52 2.27-1.4c2.37-1.62 3.69-2.91 5.38-5.55.92-1.42 1.51-2.8 1.51-2.8l9.09 4.49s-.2 7.02-3.17 10.44-9.2 3.72-9.2 3.72"
      ></path>
      <path
        fill="#c8c8c8"
        d="m81.4 92.57 5.05 7.57s6.59.65 11.99-5.82 3.96-11.79 3.96-11.79l-8.63-4.13s-1.68 4.04-5.02 7.92-7.35 6.25-7.35 6.25"
      ></path>
      <path
        fill="#cc1935"
        d="m93.93 111.33-7.47-11.18s5.63-3.29 9.63-8.02c4.15-4.91 6.32-9.58 6.32-9.58l12.09 6.01s-2.72 7.03-8.75 13.38c-5.9 6.19-11.82 9.39-11.82 9.39"
      ></path>
      <path
        fill="#006ca9"
        d="M81.61 57.37c1.13 2.11 3 2.13 4.98 1.29s11.33-7.45 11.33-7.45 12.7 6.39 20.91 3.19c8.21-3.19 7.98-11.86 7.98-11.86l-4.86-3.08s3.54-1.84 4.68-2.52c.56-.34 1.39-1.6.93-2.73-.36-.88-1.74-1.18-2.88-.72s-4.43 1.49-4.43 1.49 1.31-5.45 1.08-5.75-2.59-1.52-2.59-1.52-7.68 0-8.67.38-8.59 7.91-8.59 7.91l-3.65 7.45-1.56 3.32s-10.65 4.77-12.25 5.45c-1.59.69-3.8 2.58-2.41 5.15"
      ></path>
      <path
        fill="#1f87fd"
        d="M98.54 45.85s4.48-3.24 7.67-4.84 9.11-3.55 10.86-3.76 2.47.26 2.78 1.08-.72 1.85-1.6 2.32c-.87.46-5.51 2.57-10.65 5.3s-7.58 4.73-9.66 5.2c-1.05.24-2.4-.7-2.48-2.27-.06-1.22.18-2.24.98-4.58.98-2.88 3.13-7.21 4.94-10.03 2.68-4.17 6.54-7 10.81-7.77s7.77.31 8.65 1.03c.87.72.82 1.46.51 1.71s-.77.45-3.09-.37c-1.61-.57-6.74-.57-10.34 2.11-3.64 2.7-4.53 4.37-6.12 7.31s-3.26 7.56-3.26 7.56"
      ></path>
    </g>
  </svg>
  )
}
interface LeafAndHandsGrowProps{
  width?:number;
  height?:number;
}
const LeafAndHandsGrow = ({width,height}:LeafAndHandsGrowProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g id="SVGRepo_iconCarrier" fill="none" fillRule="evenodd">
      <path
        fill="#80D25B"
        d="M37.686 27.995c-3.937 2.86-10.55 1.751-13.432-2.216S19.863 6.334 19.863 6.334s14.964 4.445 18.525 8.368 3.234 10.433-.702 13.293"
      ></path>
      <path
        stroke="#22BA8E"
        strokeLinecap="round"
        strokeWidth="2"
        d="M23 10s9.114 5.649 12.428 16.053C36.281 28.73 37.564 30.64 39 32"
      ></path>
      <path
        stroke="#22BA8E"
        strokeLinecap="round"
        strokeWidth="2"
        d="m28 24 6.065-.285L37 18M26 18l4.541-.803L32 14"
      ></path>
      <path
        fill="#FCC24C"
        d="M48.714 30.425a1.995 1.995 0 0 1 2.744-.685l6.858 4.12-2.06 3.43-6.858-4.121a1.995 1.995 0 0 1-.684-2.744"
      ></path>
      <path
        fill="#FFDD95"
        d="m51.16 56.361-.018-8.372s-5.92-10.718-3.941-12.315 4.81 4.268 4.81 4.268l1.471-2.337.14-7.69-1.78-3.371a2.02 2.02 0 0 1 .826-2.71l-.157.084a2.004 2.004 0 0 1 2.71.824l2.56 4.758 1.144 8.655s2.152 3.315-.685 17.876"
      ></path>
      <path fill="#595959" d="M48 56h13v6H48z"></path>
      <path
        fill="#FCC24C"
        d="M17.286 30.425a1.995 1.995 0 0 0-2.744-.685l-6.858 4.12 2.06 3.43 6.858-4.121a1.995 1.995 0 0 0 .684-2.744"
      ></path>
      <path
        fill="#FFDD95"
        d="m14.84 56.361.018-8.372s5.92-10.718 3.941-12.315-4.81 4.268-4.81 4.268l-1.471-2.337-.14-7.69 1.78-3.371a2.02 2.02 0 0 0-.826-2.71l.157.084a2.004 2.004 0 0 0-2.71.824L8.22 29.5l-1.144 8.655S4.923 41.47 7.76 56.03"
      ></path>
      <path fill="#595959" d="M18 56H5v6h13z"></path>
    </g>
  </svg>
  )
}
interface AwardBadgeProps{
  width?:number;
  height?:number;
  fillBottom?:string;
  fillTop?:string;
}
const AwardBadge = ({width,height,fillBottom,fillTop}:AwardBadgeProps) =>{
  return(
    <svg
    width={width ?? 30}
    height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    fill="#000"
    version="1.1"
    viewBox="-10 0 63.999 63.999"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        id="Shape_34_"
        fill="#CCC"
        d="M12 39.999v24L22 56l10 7.999v-24z"
      ></path>
      <path
        id="Shape_35_"
        fill={fillBottom ?? "#75A64B"}
        fillRule="evenodd"
        d="m22 56 4 3.199v-19.2h-8v19.2z"
        clipRule="evenodd"
      ></path>
      <circle id="Shape_36_" cx="22" cy="22" r="22" fill={fillTop ?? "#88C057"}></circle>
      <path
        id="Star_1_"
        fill="#FFF"
        d="M33.991 18.312a1.32 1.32 0 0 0-1.022-.875l-6.554-1.202-3.221-5.572A1.34 1.34 0 0 0 22.028 10c-.483 0-.931.254-1.166.663l-3.22 5.572-6.554 1.202c-.48.088-.873.423-1.023.875-.15.45-.034.945.303 1.288l4.553 4.639-.826 6.304c-.062.467.145.93.536 1.207a1.36 1.36 0 0 0 1.351.13l6.047-2.707 6.046 2.707a1.37 1.37 0 0 0 1.351-.13c.393-.277.598-.74.537-1.207l-.826-6.304L33.69 19.6c.335-.343.452-.838.301-1.288"
      ></path>
    </g>
  </svg>
  )
}
interface NatureProps{
  width?:number;
  heigth?:number;
}
const Nature = ({width,heigth}:NatureProps) =>{
  return(
     <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    width={width ?? 60}
    height={heigth ?? 60}
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
  >
    <g id="SVGRepo_iconCarrier">
      <circle cx="256" cy="256" r="256" fill="#BAFFEF"></circle>
      <path
        fill="#FFF"
        d="M392.518 81.15c-2.09 0-4.064.411-5.957 1.008-5.996-8.619-15.941-14.285-27.236-14.285s-21.24 5.667-27.236 14.285c-1.893-.597-3.868-1.008-5.957-1.008-10.999 0-19.916 8.917-19.916 19.916h106.218c0-10.999-8.917-19.916-19.916-19.916"
        opacity="0.6"
      ></path>
      <circle
        cx="304.356"
        cy="306.615"
        r="175.194"
        fill="#FFFFF4"
        opacity="0.4"
      ></circle>
      <circle
        cx="304.356"
        cy="306.615"
        r="110.486"
        fill="#FFFFF4"
        opacity="0.5"
      ></circle>
      <circle cx="304.356" cy="306.615" r="50.615" fill="#FFF"></circle>
      <path
        fill="#53DC92"
        d="M.594 239.392C.242 244.888 0 250.415 0 256c0 37.21 8.005 72.53 22.281 104.431 69.036 7.728 162.446 6.68 184.171 4.491 25.806-2.6 96-13.955 107.355-19.116s5.047-40.258 5.047-40.258c-97.95 0-146.379-95.761-318.26-66.156"
      ></path>
      <path
        fill="#74FF9E"
        d="M318.853 305.548c-97.949 0-146.378-95.761-318.259-66.157-.058.901-.046 1.821-.097 2.724 151.833-26.756 196.828 74.835 285.866 74.835 0 0 3.34 22.22.399 35.5 12.962-2.532 23.275-4.93 27.045-6.644 11.354-5.161 5.046-40.258 5.046-40.258"
      ></path>
      <path
        fill="#52C883"
        d="M511.412 272.523c-165.914.158-228.783 66.057-362.767 66.057v55.742l228.911 87.02c75.487-40.805 128.093-118.441 133.856-208.819"
      ></path>
      <path
        fill="#6BEE97"
        d="M148.645 338.581v18.28c10.662 4.4 10.432 6.121 30.328 6.121 59.26 0 169.368-67.412 217.848-78.66-90.127 18.993-150.131 54.259-248.176 54.259"
      ></path>
      <path
        fill="#34BE69"
        d="M7.172 316.134C34.232 428.492 135.335 512 256 512c9.45 0 18.769-.55 27.954-1.548 13.048-35.781 30.885-105.807 30.885-105.807-66.065 0-137.806-90.839-306.581-90.839z"
      ></path>
      <path
        fill="#74FF9E"
        d="M309.614 404.426c-64.68-4.527-137.017-90.619-301.356-90.619l-1.086 2.327c.612 2.541 1.304 5.049 1.991 7.56 117.568.906 175.385 80.753 300.465 80.753z"
        opacity="0.3"
      ></path>
      <path
        fill="#FFF"
        d="M220.716 186.689c0-16.372-13.272-29.644-29.644-29.644-2.471 0-4.834.391-7.128.96-7.735-8.353-18.703-13.665-30.986-13.665-23.389 0-42.349 18.96-42.349 42.349zM416.406 186.689c0-9.135-7.405-16.54-16.54-16.54-1.379 0-2.697.218-3.977.536-4.316-4.661-10.435-7.625-17.289-7.625-13.05 0-23.629 10.579-23.629 23.629z"
      ></path>
      <path
        fill="#43AB5F"
        d="M256 512c106.248 0 197.365-64.732 236.099-156.903h-4.873c-146.177 0-249.242 114.951-370.612 115.584C156.729 496.78 204.574 512 256 512"
      ></path>
      <path
        fill="#FFF"
        d="M302.618 179.04c-2.876 0-5.594.566-8.199 1.388-8.252-11.862-21.941-19.662-37.486-19.662s-29.234 7.799-37.486 19.662c-2.605-.821-5.323-1.388-8.199-1.388-15.139 0-27.411 12.272-27.411 27.411H330.03c-.001-15.138-12.274-27.411-27.412-27.411M495.753 166.168c-3.101-1.554-6.552-2.511-10.257-2.511-2.417 0-4.701.475-6.89 1.166-6.933-9.968-18.435-16.521-31.497-16.521s-24.565 6.553-31.498 16.521c-2.189-.691-4.473-1.166-6.889-1.166-12.721 0-23.032 10.311-23.032 23.032h116.737c-1.955-6.961-4.16-13.813-6.674-20.521"
      ></path>
      <path
        fill="#FFF"
        d="M52.245 101.066h111.026c0-24.002-19.457-43.459-43.459-43.459-3.622 0-7.086.574-10.45 1.409-2.407-2.599-5.083-4.926-7.893-7.087a257.4 257.4 0 0 0-49.224 49.137M203.255 101.066c0-15.963 12.941-28.903 28.903-28.903 2.409 0 4.713.381 6.95.936 7.542-8.145 18.235-13.324 30.211-13.324 22.804 0 41.29 18.486 41.29 41.29z"
        opacity="0.6"
      ></path>
      <path
        fill="#FFF"
        d="M247.742 115.613c0-15.963 12.941-28.903 28.903-28.903 2.409 0 4.713.381 6.95.936 7.542-8.145 18.235-13.324 30.211-13.324 22.804 0 41.29 18.486 41.29 41.29z"
      ></path>
      <path
        fill="#53DC92"
        d="M72.552 240.722a2.77 2.77 0 0 1-2.774-2.772v-29.858a2.77 2.77 0 0 1 2.774-2.772 2.77 2.77 0 0 1 2.774 2.772v29.858a2.773 2.773 0 0 1-2.774 2.772"
      ></path>
      <path
        fill="#53DC92"
        d="M89.613 205.959c0 9.423-7.639 17.062-17.062 17.062s-17.062-7.639-17.062-17.062 7.639-38.389 17.062-38.389 17.062 28.966 17.062 38.389"
      ></path>
      <path
        fill="#52C883"
        d="M412.435 294.464a4.46 4.46 0 0 1-4.464-4.46v-48.042a4.46 4.46 0 0 1 4.464-4.46 4.46 4.46 0 0 1 4.464 4.46v48.042a4.46 4.46 0 0 1-4.464 4.46"
      ></path>
      <path
        fill="#52C883"
        d="M439.886 238.531c0 15.161-12.291 27.452-27.452 27.452s-27.452-12.291-27.452-27.452 12.291-61.768 27.452-61.768 27.452 46.606 27.452 61.768M466.311 289.29a2.795 2.795 0 0 1-2.797-2.794v-30.099c0-1.543 1.251-2.794 2.797-2.794s2.797 1.251 2.797 2.794v30.099a2.796 2.796 0 0 1-2.797 2.794"
      ></path>
      <path
        fill="#52C883"
        d="M483.509 254.247c0 9.499-7.7 17.199-17.199 17.199s-17.199-7.7-17.199-17.199 7.7-38.698 17.199-38.698 17.199 29.199 17.199 38.698"
      ></path>
      <path
        fill="#6BEE97"
        d="M187.622 348.046a2.863 2.863 0 0 1-2.864-2.862v-30.826a2.863 2.863 0 0 1 5.728 0v30.826a2.863 2.863 0 0 1-2.864 2.862"
      ></path>
      <path
        fill="#6BEE97"
        d="M205.236 312.157c0 9.728-7.886 17.615-17.615 17.615s-17.615-7.886-17.615-17.615 7.886-39.633 17.615-39.633c9.728-.001 17.615 29.904 17.615 39.633"
      ></path>
      <path
        fill="#74FF9E"
        d="M105.274 242.931a1.72 1.72 0 0 1-1.723-1.721v-18.542c0-.951.771-1.721 1.723-1.721s1.723.771 1.723 1.721v18.542c0 .951-.771 1.721-1.723 1.721"
      ></path>
      <path
        fill="#74FF9E"
        d="M115.869 221.344c0 5.852-4.744 10.595-10.595 10.595s-10.595-4.744-10.595-10.595 4.744-23.839 10.595-23.839 10.595 17.988 10.595 23.839"
      ></path>
    </g>
  </svg>
  )
}
interface StarProps{
  width?:number;
  height?:number;
}
const Star = ({width,height}:StarProps) => {
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#f39c12"
        d="m12 0 4 9 8 1-6 5 2 9-8-5-8 5 2-9-6-5 8-1z"
      ></path>
      <path
        fill="#f1c40f"
        d="M12 0 8 9l-6.969.8L6 14l-.187.8L6 15l-1.75 7.8L12 18l7.75 4.8L18 15l.188-.2L18 14l4.969-4.2L16 9z"
      ></path>
    </g>
  </svg>
  )
}
interface ThinkingAvatarProps{
  width?:number;
  height?:number;
}
const ThinkingAvatar = ({width,height}:ThinkingAvatarProps) =>{
  return(
    <svg width={width ?? 60} height={height ?? 60} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 500 500">
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#5C00BA"
        fillRule="evenodd"
        d="M363.29 82.823c-20.848-30.146-74.621-56.235-108.243-48.158-20.768 4.989-17.236 25.825-25.1 28.063s-48.869 17.126-52.688 40.892 12.779 25.892 12.239 34.1-27.116 36.3-16.451 56.517 24.362 20.271 25.151 28.949 12.963 83.867 38.043 107.522 80.766 110.422 95.692 95.443 12.389-13.8 23.569-20.611c7.736-4.712 25.786-8.7 35.022-32.349 8.809-22.558-10.572-55.973-8.914-70.208.729-6.267 22.723-13.461 17.149-41.356s-27.258-54.592-26.9-70.274c.175-7.771 13.471-7.645 17.366-29.514 3.052-17.138-10.523-56.73-25.933-79.014z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFA775"
        fillRule="evenodd"
        d="M154.093 303.934c-8.181-15.812-14.625-32.343-13.916-50.8 8.938-1.773 15.888-7.8 18.2-23.2-.729 4.856 9.271 7.456 13.575 5.783 9.128-3.553 16.175-19 12.654-23.609 3.114-4.769 7.239-13.651 2.031-18.127 0 0 4.461-13.831-1.8-16.8-5.731-2.716-16.979-2.313-16.979-2.313 5.235-5.589 9.492-9.615 14.308-14.645 3.428.826 10.34 1.907 13 1.706 13.241-1 14.875-15.341 8.784-16.063-21.961-2.593-25.868-5.69-30.475-2.905-3.535 2.135-30.4 27.982-33 31.923-12.126 18.324-34.64 51.65-38.755 68.017-6.223 24.752 8.59 151.068 43.233 150.537 22.319-.343 40.255-29.7 46.011-45.108-5.628-20.742-20.01-49.138-36.869-44.4z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#29263B"
        d="M158.791 229.937a.97.97 0 0 1-.84-.485.97.97 0 0 1-.097-.735 61.4 61.4 0 0 0 1.809-10.731.97.97 0 0 1 1.572-.674c2.426 2 5.171 3.578 8.121 4.667a.973.973 0 0 1 .591 1.237.973.973 0 0 1-1.237.591 28.8 28.8 0 0 1-7.284-3.911 61.4 61.4 0 0 1-1.7 9.321.97.97 0 0 1-.935.72"
      ></path>
      <path
        fill="#FFC764"
        fillRule="evenodd"
        d="M231.518 227.2c-9.35-4.231-23.555-14.065-37.982-6.206-20.252 11.029-39.95 82.917-39.95 82.917 8.917-1.229 16.149 12.9 22.443 23.35 12.1 54.485 12.082 100.167 11.152 145.189 46.252 23.621 116.211 23.178 155.226-.015 0 0-.512-52.97 2.68-69.568 2.99-15.547 29.846-36.1 29.846-36.1s27.829-97.179 4-125.564c-14.458-17.221-36.007-16.213-62.3-6.322-35.619 13.394-71.728-1.622-85.108-7.677z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFA775"
        fillRule="evenodd"
        d="M225.111 114.9s-21.083 59.555-10.584 77.922 40.288 22.714 40.288 22.714l-2.368 18.9-21.457-7.425c-6.2 23.306-.443 49.918 14.844 72.918 20.195-15.156 43.887-36.459 71.834-65.244 0 0-19.118 8.131-22.714.18s11.074-40.324 11.074-40.324c22.84 15.159 40.816-19.717 11.779-23.54 5.409-22.009-6.546-23.638-7.089-34.367-.693-13.757 12.41-14.971 12.114-29.737-23.3 7.378-29.815-18.741-52.387-11.2-18.917 6.323-17.908 21.424-45.334 19.2z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F08855"
        fillRule="evenodd"
        d="M283.455 212.536c-5.249 3-20.325 4.357-28.64 3l-1.4 11.148c13.992.665 23.6-5.296 30.04-14.148"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFA775"
        fillRule="evenodd"
        d="m316.226 353.55-7.141 24.436s-94.646.237-101.828 1.087c-21.745 2.578-48.928 18.466-54.558 22.712-7 5.277-8.15 18.071 4.15 20.988 5.243 13.956 13.054 33.286 20.25 35.079 10.008 2.5 11.971-6.306 12.111-12.6 6.355 6.138 31.312 4.528 36.213-12.381 15.173 2.183 106.605 3.833 118.525-4.833s30.663-61.645 30.663-61.645c-14.569-12.287-36.062-15.947-58.385-12.841z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#29263B"
        d="M317 387.947a.96.96 0 0 1-.741-.343l-8.725-10.331a.98.98 0 0 1-.225-.707.97.97 0 0 1 .671-.841.98.98 0 0 1 .739.062 1 1 0 0 1 .296.236l8.725 10.331a.96.96 0 0 1 .139 1.033.97.97 0 0 1-.879.56M184.834 213.083a.96.96 0 0 1-.682-.282 61.3 61.3 0 0 0-20.973-13.449.97.97 0 1 1 .727-1.8 63.1 63.1 0 0 1 21.611 13.87.97.97 0 0 1-.683 1.658zM186.875 194.865a1 1 0 0 1-.381-.078 89.3 89.3 0 0 0-26.785-6.881 1 1 0 0 1-.361-.112 1 1 0 0 1-.291-.241.95.95 0 0 1-.212-.711 1 1 0 0 1 .112-.361.956.956 0 0 1 .952-.503 91.2 91.2 0 0 1 27.351 7.027.97.97 0 0 1-.382 1.86zM156.065 175.758a.97.97 0 0 1 0-1.939l11.928-.049a.968.968 0 0 1 .692 1.651.97.97 0 0 1-.684.287l-11.929.05zM175.727 327.529a.97.97 0 0 1-.954-.8c-2.574-14.815 20.19-53.965 21.161-55.624a.965.965 0 0 1 1.331-.356.96.96 0 0 1 .47.975 1 1 0 0 1-.128.359c-.234.4-23.378 40.193-20.924 54.314a.97.97 0 0 1-.789 1.121 1 1 0 0 1-.167.011M311.145 355.291a.965.965 0 0 1-.953-.79.96.96 0 0 1 .02-.443c5.5-19.324 8.654-35.745 9.66-50.2a.96.96 0 0 1 .656-.857 1 1 0 0 1 .378-.043.97.97 0 0 1 .9 1.034c-.99 14.228-4.039 30.318-9.318 49.143l3.806-.589a.96.96 0 0 1 .721.175.97.97 0 0 1 .387.633.96.96 0 0 1-.175.721.97.97 0 0 1-.633.387l-5.3.819a1 1 0 0 1-.149.01M242.114 167.345a1 1 0 0 1-.327-.056c-.342-.123-8.359-3.057-8.147-8.231.194-4.773 8.248-18.186 12.667-22.087a.96.96 0 0 1 .702-.241.965.965 0 0 1 .856.653.96.96 0 0 1-.046.74 1 1 0 0 1-.229.301c-3.99 3.522-11.841 16.5-12.014 20.713-.127 3.117 4.913 5.624 6.865 6.327a.965.965 0 0 1 .627 1.078.966.966 0 0 1-.954.803M260.4 185.684a.96.96 0 0 1-.872-.546 11.07 11.07 0 0 0-6.11-5.932 6.8 6.8 0 0 0-2.653-.393 6.8 6.8 0 0 0-2.599.666.97.97 0 0 1-1.354-1.172.97.97 0 0 1 .486-.561 8.706 8.706 0 0 1 6.743-.375 12.98 12.98 0 0 1 7.23 6.92.96.96 0 0 1-.05.937.97.97 0 0 1-.821.456M297.474 131.85a2.32 2.32 0 0 1-2.238-1.695c-1.3-4.613-3.242-7.665-5.765-9.068-2.223-1.235-5.062-1.329-8.681-.287a2.327 2.327 0 0 1-1.289-4.469c4.8-1.385 8.917-1.152 12.23.69 3.7 2.056 6.308 5.939 7.983 11.871a2.33 2.33 0 0 1-2.24 2.958M229.981 125.021a2.33 2.33 0 0 1-2.036-1.207 2.33 2.33 0 0 1 .074-2.365c5.008-7.9 10.867-7.049 14.9-4.946a2.324 2.324 0 0 1 .987 3.138 2.324 2.324 0 0 1-3.138.987c-2.621-1.368-5.5-1.914-8.818 3.312a2.32 2.32 0 0 1-1.969 1.081"
      ></path>
      <path
        fill="#29263B"
        fillRule="evenodd"
        d="M284.857 129.365c2.295.587 3.206 4.787 2.034 9.374s-3.99 7.835-6.282 7.248-3.206-4.788-2.033-9.374 3.987-7.835 6.281-7.248M235.6 126.052c2.115.412 3.161 4.179 2.34 8.406s-3.209 7.321-5.323 6.909-3.161-4.177-2.34-8.4 3.209-7.324 5.323-6.912z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#494645"
        d="M314.009 189.839a1.123 1.123 0 0 1-.974-1.687c3.11-5.4 8.043-7.918 14.664-7.491a1.13 1.13 0 0 1 .787.373 1.123 1.123 0 0 1-.103 1.602 1.13 1.13 0 0 1-.828.27c-5.78-.378-9.887 1.712-12.571 6.369a1.123 1.123 0 0 1-.975.564"
      ></path>
      <path
        fill="#E1B100"
        fillRule="evenodd"
        d="M105.728 34.724c-.063-12.989 10.027-24.266 32.612-24.714S176 23.709 173.3 34.665c-3.521 14.292-28.06 18.305-27.66 33.382.06 2.294-14.88 2.087-14.88-.208-.344-15.018 29.459-22.274 29.909-33.455.394-9.8-7.612-15.115-22.208-15.115-10.142 0-18.665 5.224-19.412 15.338-.128 2.138-13.312 2.258-13.323.117zM138.119 75.172c5.692 0 10.312 3.06 10.312 6.831s-4.62 6.83-10.312 6.83-10.311-3.06-10.311-6.83 4.62-6.831 10.311-6.831"
        clipRule="evenodd"
      ></path>
    </g>
  </svg>
  )
}
interface ChatCloudProps{
  width?:number;
  height?:number;
  fill?:string;
}
const ChatCloud = ({width,height,fill}:ChatCloudProps) => {
  return(
      <svg
      width={width ?? 30}
      height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Message_And_Communication_Icons"
    fill={fill ?? "#000"}
    version="1.1"
    viewBox="0 0 50 50"
  >
    <g id="SVGRepo_iconCarrier">
      <path
      opacity={0}
        fill={fill ??'white'}
        d="M35.8 12.1c2.1 2.7 3.3 6.1 3.3 9.8C39.1 30.8 31.9 38 23 38c-2.5 0-4.8-.6-6.9-1.6l-.7.7v6l3.7-3.7c2.1 1 4.4 1.6 6.9 1.6 8.9 0 16.1-7.2 16.1-16.1 0-5.2-2.5-9.8-6.3-12.8"
      ></path>
      <path
      
        fill={fill ??'white'}
        d="M13.8 43.6v-7.3c-3.5-3.2-5.5-7.7-5.5-12.4 0-9.2 7.5-16.7 16.7-16.7s16.7 7.5 16.7 16.7S34.2 40.6 25 40.6c-2.3 0-4.6-.5-6.8-1.5zM25 8.4c-8.5 0-15.5 6.9-15.5 15.5 0 4.4 1.9 8.7 5.3 11.6l.2.2v4.9l3-3 .4.2q3.15 1.5 6.6 1.5c8.5 0 15.5-6.9 15.5-15.5S33.5 8.4 25 8.4"
      ></path>
      <path
      opacity={0}
        fill={fill ??'white'}
        d="m15.4 15.2-.9-.8c.4-.5.9-.9 1.4-1.3l.8.9c-.4.4-.9.8-1.3 1.2M12 24.1h-1.2c0-3 .9-5.9 2.7-8.3l1 .7c-1.7 2.2-2.5 4.8-2.5 7.6M32.8 20.3c-.7-.7-1.5-1-2.4-1.1.9 1.5.7 3.5-.6 4.8l-6.3 6.3 2.5 2.5 6.8-6.8c1.5-1.6 1.5-4.1 0-5.7"
      ></path>
      <path
      
        fill={fill ??'white'}
        d="m25 32.6-.5-.4-6.8-6.8c-1.8-1.8-1.8-4.7 0-6.5s4.7-1.8 6.5 0l.7.7.7-.7c1.8-1.8 4.7-1.8 6.5 0s1.8 4.7 0 6.5zm-3.9-13.8c-.9 0-1.7.3-2.4 1-1.3 1.3-1.3 3.5 0 4.8l6.3 6.3 6.3-6.3c1.3-1.3 1.3-3.5 0-4.8s-3.5-1.3-4.8 0L25 21.3l-1.5-1.5c-.7-.7-1.6-1-2.4-1"
      ></path>
    </g>
  </svg>
)
}
interface SwishIconProps {
  width?: number;
  height?: number;
  wordmarkFill?: string;
}
// const StripeIcon = () => {
//   return(<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -9 58 58">
//     <g id="SVGRepo_iconCarrier">
//       <rect
//         width="57"
//         height="39"
//         x="0.5"
//         y="0.5"
//         fill="#fff"
//         stroke="#F3F3F3"
//         rx="3.5"
//       ></rect>
//       <path
//         fill="#6772E5"
//         fillRule="evenodd"
//         d="m30.656 14.3-2.79.613V12.6l2.79-.601zm5.8 1.281c-1.09 0-1.79.522-2.178.884l-.145-.702H31.69v13.214l2.778-.6.01-3.208c.4.295.99.714 1.967.714 1.99 0 3.8-1.632 3.8-5.224-.01-3.287-1.844-5.078-3.788-5.078m-.667 7.809c-.656 0-1.045-.238-1.311-.533l-.011-4.204c.289-.329.689-.556 1.322-.556 1.011 0 1.711 1.156 1.711 2.641 0 1.519-.689 2.652-1.711 2.652M49 20.772c0-2.901-1.378-5.19-4.011-5.19-2.645 0-4.245 2.289-4.245 5.167 0 3.412 1.89 5.134 4.6 5.134 1.323 0 2.323-.306 3.078-.736V22.88c-.755.385-1.622.623-2.722.623-1.078 0-2.033-.385-2.156-1.722h5.434c0-.063.004-.205.008-.368.007-.222.014-.484.014-.641m-5.489-1.077c0-1.28.767-1.813 1.467-1.813.678 0 1.4.533 1.4 1.813zm-15.644-3.921h2.789v9.917h-2.79zm-3.167 0 .178.839c.655-1.224 1.955-.975 2.31-.839v2.607c-.344-.125-1.455-.284-2.11.589v6.72H22.3v-9.916zm-5.378-2.46-2.71.59-.012 9.078c0 1.677 1.233 2.913 2.878 2.913.91 0 1.578-.17 1.944-.374V23.22c-.355.147-2.11.669-2.11-1.009v-4.023h2.11v-2.414h-2.11zm-6.566 4.727c-.59 0-.945.17-.945.612 0 .482.612.695 1.371.958 1.238.43 2.867.994 2.874 3.088 0 2.028-1.59 3.196-3.9 3.196-.956 0-2-.193-3.034-.646V22.55c.934.522 2.111.907 3.034.907.622 0 1.066-.17 1.066-.691 0-.535-.663-.78-1.464-1.074C10.538 21.243 9 20.677 9 18.789c0-2.006 1.5-3.208 3.756-3.208a7.2 7.2 0 0 1 2.755.522v2.663c-.844-.465-1.911-.725-2.755-.725"
//         clipRule="evenodd"
//       ></path>
//     </g>
//   </svg>)
// }
const SwishIcon = ({ width = 80, height = 80, wordmarkFill = "#17191f" }: SwishIconProps) => {
 return( <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 566">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="-746"
        x2="-746.2"
        y1="822.6"
        y2="823.1"
        gradientTransform="matrix(300.3 0 0 -370.5 224261.6 305063)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ef2131"></stop>
        <stop offset="1" stopColor="#fecf2c"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="-745.4"
        x2="-745.9"
        y1="823"
        y2="822.1"
        gradientTransform="matrix(273.8 0 0 -300.2 204470.4 247194.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fbc52c"></stop>
        <stop offset="0.3" stopColor="#f87130"></stop>
        <stop offset="0.6" stopColor="#ef52e2"></stop>
        <stop offset="1" stopColor="#661eec"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="-746"
        x2="-745.8"
        y1="823"
        y2="822.5"
        gradientTransform="matrix(300.3 0 0 -370.5 224142 305014)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#78f6d8"></stop>
        <stop offset="0.3" stopColor="#77d1f6"></stop>
        <stop offset="0.6" stopColor="#70a4f3"></stop>
        <stop offset="1" stopColor="#661eec"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        x1="-746.1"
        x2="-745.6"
        y1="822.3"
        y2="823.2"
        gradientTransform="matrix(273.8 0 0 -300.2 204377.3 247074.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#536eed"></stop>
        <stop offset="0.2" stopColor="#54c3ec"></stop>
        <stop offset="0.6" stopColor="#64d769"></stop>
        <stop offset="1" stopColor="#fecf2c"></stop>
      </linearGradient>
    </defs>
    <g id="Layer_1">
      <g id="_x30_1-Primary-_x28_Vertical_x29__x2F_Colour_x2F_Light-background_x2F_Swish_x5F_Logo_x5F_Primary_x5F_Light-BG">
        <g id="Wordmark_x2F_Swish">
          <path
            id="swish_xAE_"
            fill={wordmarkFill}
            d="M381.4 485.9c0-2 .4-3.9 1.1-5.7s1.8-3.3 3-4.6c1.3-1.3 2.8-2.4 4.5-3.1 1.7-.8 3.6-1.1 5.5-1.1s3.9.4 5.6 1.1c1.7.8 3.3 1.8 4.6 3.1s2.3 2.9 3.1 4.6c.7 1.8 1.1 3.7 1.1 5.7s-.4 3.9-1.1 5.7-1.8 3.3-3.1 4.6-2.8 2.4-4.6 3.1c-1.7.8-3.6 1.1-5.6 1.1s-3.8-.4-5.5-1.1c-1.7-.8-3.2-1.8-4.5-3.1s-2.3-2.9-3-4.6c-.7-1.8-1.1-3.7-1.1-5.7m2.9 0c0 1.7.3 3.2.9 4.7.6 1.4 1.4 2.7 2.4 3.8s2.2 1.9 3.6 2.5q2.1.9 4.5.9c2.4 0 3.1-.3 4.5-.9s2.6-1.5 3.6-2.5 1.8-2.3 2.4-3.8c.6-1.4.9-3 .9-4.7s-.3-3.2-.9-4.7c-.6-1.4-1.4-2.7-2.4-3.8s-2.2-1.9-3.6-2.5q-2.1-.9-4.5-.9c-2.4 0-3.1.3-4.5.9s-2.6 1.5-3.6 2.5c-1 1.1-1.8 2.3-2.4 3.8-.6 1.4-.9 3-.9 4.7m6.4-6.3c0-.9.4-1.3 1.3-1.3h4.5c1.4 0 2.6.4 3.4 1.2.9.8 1.3 1.9 1.3 3.4s0 1.1-.3 1.6c-.2.5-.4.8-.7 1.2-.3.3-.6.6-.9.8s-.6.4-1 .4c0 .1 0 .2.1.2 0 0 .1.1.2.3 0 .1.1.3.2.4l2.1 4c.2.5.3.8.2 1.1s-.4.4-.9.4h-.5c-.7 0-1.3-.3-1.6-1l-2.3-4.9h-2.5v4.6c0 .9-.4 1.3-1.2 1.3h-.4c-.8 0-1.2-.4-1.2-1.3v-12.5Zm5.3 5.8c.8 0 1.4-.2 1.8-.7s.6-1.1.6-1.9-.2-1.4-.6-1.8q-.6-.6-1.8-.6h-2.4v5zM279.3 495c4.5 0 8.4.6 11.5 1.7 3.2 1.2 5.6 2.2 7.4 3.2 1.5.8 2.4 1.9 2.7 3.2s0 2.7-.7 4.3l-1.3 2.4c-.8 1.6-1.8 2.5-3.1 2.8s-2.7 0-4.4-.7c-1.5-.7-3.3-1.4-5.5-2.2s-4.6-1.1-7.5-1.1-5.2.6-6.8 1.7c-1.6 1.2-2.4 2.8-2.4 4.9s.8 3.4 2.5 4.5c1.6 1.2 3.7 2.2 6.3 3.1 2.5.9 5.2 1.8 8.1 2.9q4.35 1.5 8.1 3.9c3.75 2.4 4.6 3.6 6.3 6.1 1.6 2.5 2.5 5.6 2.5 9.4s-.6 5.8-1.8 8.3-2.9 4.7-5.2 6.6-5 3.3-8.2 4.4-6.7 1.6-10.7 1.6-10.1-.8-13.9-2.4q-5.7-2.4-8.7-4.5c-1.5-.9-2.4-2-2.5-3.3-.2-1.3.2-2.7 1.2-4.3l1.6-2.4q1.5-2.1 3.3-2.4c1.8-.3 2.6.2 4.3 1.1 1.6.9 3.7 1.9 6.2 3s5.5 1.7 9 1.7 5.2-.6 6.9-1.9 2.5-2.9 2.5-5.1-.8-3.3-2.5-4.5c-1.6-1.1-3.7-2.1-6.3-3.1q-3.75-1.35-8.1-3c-2.9-1.1-5.6-2.4-8.1-4s-4.6-3.6-6.3-6.1c-1.6-2.5-2.5-5.7-2.5-9.6s.7-6.2 2.1-8.8 3.2-4.7 5.6-6.4 5.1-3 8.3-3.9 6.5-1.3 10.1-1.3Zm-198 0c4.5 0 8.4.6 11.5 1.7s5.6 2.2 7.4 3.2c1.5.8 2.4 1.9 2.7 3.2s0 2.7-.7 4.3l-1.3 2.4c-.8 1.6-1.8 2.5-3.1 2.8s-2.7 0-4.4-.7c-1.5-.7-3.3-1.4-5.5-2.2-2.1-.8-4.6-1.1-7.5-1.1s-5.2.6-6.8 1.7c-1.6 1.2-2.4 2.8-2.4 4.9s.8 3.4 2.5 4.5c1.6 1.2 3.7 2.2 6.3 3.1 2.5.9 5.2 1.8 8.1 2.9q4.35 1.5 8.1 3.9c2.5 1.6 4.6 3.6 6.3 6.1 1.6 2.5 2.5 5.6 2.5 9.4s-.6 5.8-1.8 8.3-2.9 4.7-5.2 6.6-5 3.3-8.2 4.4-6.7 1.6-10.7 1.6-10.1-.8-13.9-2.4q-5.7-2.4-8.7-4.5c-1.5-.9-2.4-2-2.5-3.3-.2-1.3.2-2.7 1.2-4.3l1.6-2.4q1.5-2.1 3.3-2.4c1.2-.2 2.6.2 4.3 1.1 1.6.9 3.7 1.9 6.2 3s5.5 1.7 9 1.7 5.2-.6 6.9-1.9c1.7-1.2 2.5-2.9 2.5-5.1s-.8-3.3-2.5-4.5c-1.6-1.1-3.7-2.1-6.3-3.1q-3.75-1.35-8.1-3c-2.9-1.1-5.6-2.4-8.1-4s-4.6-3.6-6.3-6.1-2.5-5.7-2.5-9.6.7-6.2 2.1-8.8 3.2-4.7 5.6-6.4 5.1-3 8.3-3.9 6.5-1.3 10.1-1.3Zm242.8-25c3.7 0 5.6 1.9 5.6 5.6v29.7c0 .7-.1 1.3-.2 1.8 0 .6-.1 1.2-.1 1.6h.3c.8-1.6 1.9-3.2 3.4-4.9 1.5-1.6 3.2-3.1 5.2-4.5 2-1.3 4.3-2.4 6.8-3.2s5.3-1.2 8.2-1.2c7.5 0 13.4 2 17.5 6.1s6.2 10.6 6.2 19.7v38c0 3.7-1.9 5.6-5.6 5.6h-5.7c-3.7 0-5.6-1.9-5.6-5.6v-34.6c0-4.2-.7-7.5-2.1-10s-4.3-3.8-8.5-3.8-5.6.6-8.1 1.7c-2.4 1.2-4.5 2.7-6.2 4.7s-3 4.4-3.9 7.1-1.4 5.7-1.4 8.9v25.9c0 3.7-1.9 5.6-5.6 5.6h-5.7c-3.7 0-5.6-1.9-5.6-5.6v-83.2c0-3.7 1.9-5.6 5.6-5.6h5.7Zm-88.4 26.6c3.6 0 5.5 1.9 5.5 5.6v56.6c0 3.7-1.8 5.6-5.5 5.6h-5.9c-3.6 0-5.5-1.9-5.5-5.6v-56.6c0-3.7 1.8-5.6 5.5-5.6zm-113 0c3.4 0 5.4 1.6 6 4.9l10.9 39.6c.2 1 .3 1.9.5 2.7.1.8.3 1.6.5 2.3.2.8.3 1.6.4 2.3h.3c0-.7.2-1.5.4-2.3.2-.7.3-1.5.5-2.3q.15-1.2.6-2.7l11.5-39.6c.6-3.2 2.7-4.8 6.1-4.8h5.1c3.3 0 5.3 1.6 6.1 4.8l11.3 39.6q.45 1.5.6 2.7c.1.8.3 1.6.5 2.3.2.8.3 1.6.4 2.3h.3c0-.7.2-1.5.4-2.3.2-.7.3-1.5.5-2.3q.15-1.2.6-2.7l10.8-39.6c.8-3.3 2.8-4.9 6.1-4.9h6.1c2 0 3.5.6 4.3 1.7.8 1.2.9 2.7.4 4.5l-17.4 56.9c-.9 3.1-3 4.7-6.3 4.7h-8.9q-5.1 0-6.3-4.8l-10.3-33.9c-.3-.9-.5-1.8-.7-2.7s-.4-1.7-.5-2.4c-.2-.8-.3-1.6-.4-2.3h-.3c-.2.7-.4 1.5-.5 2.3-.2.7-.4 1.5-.5 2.4-.2.9-.4 1.8-.7 2.7l-10.3 33.9c-.8 3.2-2.8 4.8-6.1 4.8h-9.2c-3.2 0-5.2-1.6-6.1-4.7l-17.6-56.9c-.5-1.9-.4-3.4.5-4.5.8-1.2 2.2-1.7 4.2-1.7h6.4Z"
          ></path>
        </g>
        <g id="Symbol_x2F_Colour">
          <g id="Right-Swirl">
            <path
              id="Base-Shape"
              fill="url(#linear-gradient)"
              fillRule="evenodd"
              d="M119.3 399.2c84.3 40.3 188.3 20.4 251.2-54.5 74.5-88.8 62.9-221.1-25.8-295.5l-59 70.3c69.3 58.2 78.4 161.5 20.2 230.9-46.4 55.3-122.8 73.7-186.5 48.9"
            ></path>
            <path
              id="Light-Cast"
              fill="url(#linear-gradient-2)"
              fillRule="evenodd"
              d="M119.3 399.2c84.3 40.3 188.3 20.4 251.2-54.5 7.7-9.2 14.5-18.8 20.3-28.8 9.9-61.7-11.9-126.9-63.2-169.9-13-10.9-27.2-19.8-41.9-26.5 69.3 58.2 78.4 161.5 20.2 230.9-46.4 55.3-122.8 73.7-186.5 48.9"
            ></path>
          </g>
          <g id="Left-Swirl">
            <path
              id="Base-shape"
              fill="url(#linear-gradient-3)"
              fillRule="evenodd"
              d="M300.3 20.4C216-19.9 111.9 0 49.1 74.9-25.4 163.7-13.8 296 74.9 370.4l59-70.3c-69.3-58.2-78.4-161.5-20.2-230.9C160.2 14 236.6-4.5 300.3 20.4"
            ></path>
            <path
              id="Shadow"
              fill="url(#linear-gradient-4)"
              fillRule="evenodd"
              d="M300.3 20.4C216-19.9 111.9 0 49.1 74.9c-7.7 9.2-14.5 18.8-20.3 28.8-9.9 61.7 11.9 126.9 63.2 169.9 13 10.9 27.2 19.8 41.9 26.5-69.3-58.2-78.4-161.5-20.2-230.9C160.2 14 236.6-4.5 300.3 20.4"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>)
}
interface StripeIconProps {
  width?: number;
  height?: number;
}

const StripeIcon = ({ width = 80, height = 80 }: StripeIconProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 1024 1024">
    <g id="SVGRepo_iconCarrier">
      <circle cx="512" cy="512" r="512" fill="#635bff"></circle>
      <path
        fill="#fff"
        d="M781.67 515.75c0-38.35-18.58-68.62-54.08-68.62s-57.23 30.26-57.23 68.32c0 45.09 25.47 67.87 62 67.87 17.83 0 31.31-4 41.5-9.74v-30c-10.19 5.09-21.87 8.24-36.7 8.24-14.53 0-27.42-5.09-29.06-22.77h73.26c.01-1.92.31-9.71.31-13.3m-74-14.23c0-16.93 10.34-24 19.78-24 9.14 0 18.88 7 18.88 24zm-95.14-54.39a42.32 42.32 0 0 0-29.36 11.69l-1.95-9.29h-33v174.68l37.45-7.94.15-42.4c5.39 3.9 13.33 9.44 26.52 9.44 26.82 0 51.24-21.57 51.24-69.06-.12-43.45-24.84-67.12-51.05-67.12m-9 103.22c-8.84 0-14.08-3.15-17.68-7l-.15-55.58c3.9-4.34 9.29-7.34 17.83-7.34 13.63 0 23.07 15.28 23.07 34.91.01 20.03-9.28 35.01-23.06 35.01zM496.72 438.29l37.6-8.09v-30.41l-37.6 7.94zm0 11.39h37.6v131.09h-37.6zm-40.3 11.08L454 449.68h-32.34v131.08h37.45v-88.84c8.84-11.54 23.82-9.44 28.46-7.79v-34.45c-4.78-1.8-22.31-5.1-31.15 11.08m-74.91-43.59L345 425l-.15 120c0 22.17 16.63 38.5 38.8 38.5 12.28 0 21.27-2.25 26.22-4.94v-30.45c-4.79 1.95-28.46 8.84-28.46-13.33v-53.19h28.46v-31.91h-28.51zm-101.27 70.56c0-5.84 4.79-8.09 12.73-8.09a83.56 83.56 0 0 1 37.15 9.59V454a98.8 98.8 0 0 0-37.12-6.87c-30.41 0-50.64 15.88-50.64 42.4 0 41.35 56.93 34.76 56.93 52.58 0 6.89-6 9.14-14.38 9.14-12.43 0-28.32-5.09-40.9-12v35.66a103.85 103.85 0 0 0 40.9 8.54c31.16 0 52.58-15.43 52.58-42.25-.17-44.63-57.25-36.69-57.25-53.47"
      ></path>
    </g>
  </svg>
  );
}
const KlarnaPink = () => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 609 609"
  >
    <path
      fill="#0B051D"
      d="M0 262C0 138.492 0 76.738 38.369 38.369S138.492 0 262 0h85c123.508 0 185.262 0 223.631 38.369S609 138.492 609 262v85c0 123.508 0 185.262-38.369 223.631S470.508 609 347 609h-85c-123.508 0-185.262 0-223.631-38.369S0 470.508 0 347z"
    ></path>
    <path
      fill="#FFA8CD"
      d="M449.675 110h-84.448c0 69.464-42.5 131.704-107.078 176.161l-25.389 17.783V110H145v389h87.76V306.167L377.922 499H485L345.357 314.503C408.831 268.379 450.227 196.691 449.675 110"
    ></path>
  </svg>
  )
}
interface SimpleGroupProps{
  width?:number;
  height?:number;
  fill?:string;
}
const SimpleGroup = ({width,height,fill}:SimpleGroupProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#000"}
      fillRule="evenodd"
      d="M16 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5 3a5 5 0 1 1 8.654 3.413 8.1 8.1 0 0 1 4.172 3.12 1 1 0 0 1-1.652 1.126C21.198 15.227 19.418 14 17 14c-3.834 0-6 3.074-6 5a1 1 0 1 1-2 0c0-.692.158-1.43.46-2.157a1 1 0 0 1-.211-.183C8.428 15.726 7.154 15 5.5 15s-2.928.726-3.749 1.66A1 1 0 0 1 .25 15.34a6.9 6.9 0 0 1 2.108-1.62 4.5 4.5 0 1 1 6.286 0 6.9 6.9 0 0 1 1.865 1.358 8.1 8.1 0 0 1 2.484-2.083A5 5 0 0 1 11 9m-8 1.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      clipRule="evenodd"
    ></path>
  </svg>
  )
}
interface TestLogoNavProps{
  width?:number;
  height?:number;
}
const TestLogoNav = ({width,height}:TestLogoNavProps) => {
  return(
     <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={width ?? 30}
    height={height ?? 30}
    fill="#000"
    version="1.1"
    viewBox="0 0 512 512"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#E16A54"
        d="M259.288 280.33s-48.407 6.46-98.819-11.574-83.739-53.731-83.739-53.731 48.407-6.46 98.819 11.574 83.739 53.731 83.739 53.731"
      ></path>
      <path
        fill="#9F5255"
        d="M92.783 213.936c12.589 11.421 39.95 33.435 76.102 46.368 32.622 11.669 64.398 13.082 82.767 12.626 4.966 4.504 7.636 7.364 7.636 7.364s-48.407 6.46-98.819-11.574-83.739-53.733-83.739-53.733 6.035-.802 16.053-1.051"
        opacity="0.35"
      ></path>
      <g fill="#E16A54">
        <path d="M259.288 347.886s-48.407 6.46-98.819-11.574-83.739-53.731-83.739-53.731 48.407-6.46 98.819 11.574 83.739 53.731 83.739 53.731M259.288 415.443s-48.407 6.46-98.819-11.574-83.739-53.731-83.739-53.731 48.407-6.46 98.819 11.574 83.739 53.731 83.739 53.731M259.288 483.382s-48.407 6.46-98.819-11.574-83.739-53.731-83.739-53.731 48.407-6.46 98.819 11.574 83.739 53.731 83.739 53.731M255.879 206.574s-40.94 4.497-81.085-13.306-64.297-51.164-64.297-51.164 40.94-4.497 81.085 13.306 64.297 51.164 64.297 51.164"></path>
      </g>
      <g fill="#9F5255">
        <path
          d="M125.722 141.621c9.765 11.014 29.873 30.763 57.641 43.077 25.009 11.091 50.323 13.527 65.86 13.787 4.353 4.91 6.657 8.087 6.657 8.087s-40.94 4.497-81.085-13.306-64.297-51.164-64.297-51.164 5.821-.638 15.224-.481M92.783 281.492c12.589 11.421 39.95 33.435 76.102 46.368 32.622 11.669 64.398 13.082 82.767 12.626 4.966 4.504 7.636 7.364 7.636 7.364s-48.407 6.46-98.819-11.574-83.739-53.733-83.739-53.733 6.035-.803 16.053-1.051M92.783 349.049c12.589 11.421 39.95 33.435 76.102 46.368 32.622 11.669 64.398 13.082 82.767 12.626 4.966 4.504 7.636 7.364 7.636 7.364s-48.407 6.46-98.819-11.574S76.73 350.1 76.73 350.1s6.035-.803 16.053-1.051M92.783 416.987c12.589 11.421 39.95 33.435 76.102 46.368 32.622 11.669 64.398 13.082 82.767 12.626 4.966 4.504 7.636 7.364 7.636 7.364s-48.407 6.46-98.819-11.574-83.739-53.732-83.739-53.732 6.035-.803 16.053-1.052"
          opacity="0.35"
        ></path>
      </g>
      <path
        fill="#E16A54"
        d="M256.121 199.339s-20.707-44.493-20.707-99.376S256.121.587 256.121.587s20.707 44.493 20.707 99.376-20.707 99.376-20.707 99.376"
      ></path>
      <path
        fill="#9F5255"
        d="M255.535 0s-1.248 2.684-3.129 7.537c6.052 17.905 14.03 47.965 14.03 82.034 0 41.418-11.791 76.914-17.578 91.839 3.697 10.938 6.677 17.342 6.677 17.342s20.707-44.492 20.707-99.376C276.242 44.493 255.535 0 255.535 0"
        opacity="0.35"
      ></path>
      <path
        fill="#E16A54"
        d="M252.712 280.33s48.407 6.46 98.819-11.574 83.739-53.731 83.739-53.731-48.407-6.46-98.819 11.574-83.739 53.731-83.739 53.731"
      ></path>
      <path
        fill="#9F5255"
        d="M419.217 213.936c-12.589 11.421-39.95 33.435-76.102 46.368-32.622 11.669-64.398 13.082-82.767 12.626-4.966 4.504-7.636 7.364-7.636 7.364s48.407 6.46 98.819-11.574 83.739-53.732 83.739-53.732-6.035-.803-16.053-1.052"
        opacity="0.35"
      ></path>
      <g fill="#E16A54">
        <path d="M252.712 347.886s48.407 6.46 98.819-11.574 83.739-53.731 83.739-53.731-48.407-6.46-98.819 11.574-83.739 53.731-83.739 53.731M252.712 415.443s48.407 6.46 98.819-11.574 83.739-53.731 83.739-53.731-48.407-6.46-98.819 11.574-83.739 53.731-83.739 53.731M252.712 483.382s48.407 6.46 98.819-11.574 83.739-53.731 83.739-53.731-48.407-6.46-98.819 11.574-83.739 53.731-83.739 53.731M256.121 206.574s40.94 4.497 81.085-13.306 64.297-51.164 64.297-51.164-40.94-4.497-81.085 13.306-64.297 51.164-64.297 51.164"></path>
      </g>
      <g fill="#9F5255">
        <path
          d="M386.278 141.621c-9.765 11.014-29.873 30.763-57.641 43.077-25.009 11.091-50.323 13.527-65.86 13.787-4.353 4.91-6.657 8.087-6.657 8.087s40.94 4.497 81.085-13.306 64.297-51.164 64.297-51.164-5.821-.638-15.224-.481"
          opacity="0.35"
        ></path>
        <path d="M256.121 512a7.72 7.72 0 0 1-7.722-7.722V199.339a7.72 7.72 0 0 1 7.722-7.722 7.72 7.72 0 0 1 7.721 7.722v304.939a7.72 7.72 0 0 1-7.721 7.722"></path>
        <path
          d="M419.217 281.492c-12.589 11.421-39.95 33.435-76.102 46.368-32.622 11.669-64.398 13.082-82.767 12.626-4.966 4.504-7.636 7.364-7.636 7.364s48.407 6.46 98.819-11.574 83.739-53.732 83.739-53.732-6.035-.804-16.053-1.052M419.217 349.049c-12.589 11.421-39.95 33.435-76.102 46.368-32.622 11.669-64.398 13.082-82.767 12.626-4.966 4.504-7.636 7.364-7.636 7.364s48.407 6.46 98.819-11.574 83.739-53.732 83.739-53.732-6.035-.804-16.053-1.052M419.217 416.987c-12.589 11.421-39.95 33.435-76.102 46.368-32.622 11.669-64.398 13.082-82.767 12.626-4.966 4.504-7.636 7.364-7.636 7.364s48.407 6.46 98.819-11.574 83.739-53.732 83.739-53.732-6.035-.803-16.053-1.052"
          opacity="0.35"
        ></path>
      </g>
    </g>
  </svg>
  )
}
interface LoginProps{
  width?:number;
  height?:number;
}
const LogIn = ({width,height}:LoginProps) =>{
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g
      id="SVGRepo_iconCarrier"
      stroke="#1C274C"
      strokeLinecap="round"
      strokeWidth="1.5"
    >
      <path d="M12 20a8 8 0 1 0 0-16" opacity="0.5"></path>
      <path strokeLinejoin="round" d="M4 12h10m0 0-3-3m3 3-3 3"></path>
    </g>
  </svg>
  )
}
interface CheckoutPaymentProps{
  width?:number;
  height?:number;
}
const CheckoutPayment = ({width,height}:CheckoutPaymentProps) => {
  return(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    fill="#000"
    version="1.1"
    viewBox="0 0 456.916 456.916"
    width={width ?? 30} height={height ?? 30}
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="gray"
        d="M324.204 93.839h117.971c8.141 0 14.74 6.599 14.74 14.74v239.757c0 8.141-6.599 14.74-14.74 14.74H324.204c-8.141 0-14.74-6.599-14.74-14.74V108.579c-.001-8.141 6.599-14.74 14.74-14.74"
      ></path>
      <path fill="#FFF" d="M449.959 129.378v193.409H316.423V129.378z"></path>
      <circle cx="383.189" cy="343.909" r="11.558" fill="#4D4D4D"></circle>
      <path fill="#E6E6E6" d="M449.959 281.168H316.477v-13.18h133.482z"></path>
      <path
        fill="#FFF"
        d="M441.671 363.076h-15.427v.002h15.183q.123 0 .244-.002m-.244-269.238h-97.235l97.371.001z"
      ></path>
      <path
        fill="#A9A9A9"
        d="M441.563 93.839h-97.37l10.831 35.539h94.936v193.409h-35.994l12.279 40.291 15.427-.002c8.441-.13 15.244-7.015 15.244-15.486V109.326c-.001-8.508-6.863-15.414-15.353-15.487"
      ></path>
      <path
        fill="#FFF"
        d="M449.959 281.168h-48.678l12.684 41.619h35.994zm0-151.79h-94.936l42.242 138.61h52.694z"
      ></path>
      <path fill="#EEE" d="M449.959 267.988h-52.694l4.016 13.18h48.678z"></path>
      <path
        fill="#29ABE2"
        d="M147.46 109.326V347.59c0 8.553-6.935 15.488-15.488 15.488H15.488C6.934 363.078 0 356.143 0 347.59V109.326c0-8.553 6.934-15.487 15.488-15.487h116.484c8.553-.001 15.488 6.934 15.488 15.487"
      ></path>
      <path fill="#FFF" d="M140.5 129.378v193.409H6.964V129.378z"></path>
      <circle cx="73.73" cy="343.909" r="11.558" fill="#2496B5"></circle>
      <path
        fill="#FCD18B"
        d="M402.121 189.318c-15.468 0-29.591-8.498-37.136-22.001-.942-1.686-1.852-3.104-2.667-4.066a52.3 52.3 0 0 0-15.754-12.566l-4.566-2.37a64.8 64.8 0 0 0-29.886-7.306h-24.871c-.52 0-1.039.032-1.543.094-6.212.764-11.022 6.054-11.022 12.471a12.53 12.53 0 0 0 3.685 8.889 12.54 12.54 0 0 0 8.881 3.677l-5.029 5.086s.427 8.15.75 10l2.988 2.833c2.897 0-10.885 2.519-8.988 4.417 1.905 1.897.5 3.853.5 6.75 0 5.795 8.045 16.25 2.25 16.25l1.75 5.75c2.897 0 4.095-2.397 6-.5 1.897 1.897 4.75.353 4.75 3.25 0 5.795-.705 11.5-6.5 11.5l7.75 1.25c2.897 0 6.103.103 8 2s4.75-1.139 4.75 1.75c0 5.795-1.705 8.75-7.5 8.75l3.75 6.75c2.897 0-2.148 3.353-.25 5.25 1.897 1.905-3-.897-3 2 0 5.795 8.579 8.761 2.784 8.761h100.505v-78.67h-.381z"
      ></path>
      <path
        fill="#86D359"
        d="M221.649 166.141v17.919h-63.57c-5.782 0-11.021-2.007-14.815-5.251-3.784-3.244-6.132-7.716-6.132-12.668zM314.017 184.06h-72.76400000000001v-17.919h72.267c.001 0 .174 16.069.497 17.919"
      ></path>
      <path
        fill="#DDB57A"
        d="M300.451 187.131a10.43 10.43 0 0 1 3.078 7.417c0 5.795-4.7 10.495-10.495 10.495h-20.108c-5.795 0-10.487-4.7-10.487-10.495s4.692-10.487 10.487-10.487h20.108a10.45 10.45 0 0 1 7.417 3.07"
      ></path>
      <path
        fill="#DDB57A"
        d="M310.151 208.113a10.46 10.46 0 0 1 3.071 7.417c0 5.795-4.7 10.495-10.495 10.495h-20.109c-5.795 0-10.495-4.7-10.495-10.495s4.7-10.487 10.495-10.487h20.108a10.48 10.48 0 0 1 7.425 3.07"
      ></path>
      <path
        fill="#DDB57A"
        d="M319.835 229.095a10.47 10.47 0 0 1 3.071 7.417c0 5.795-4.692 10.495-10.487 10.495h-20.108c-5.794 0-10.495-4.7-10.495-10.495 0-5.787 4.7-10.487 10.495-10.487h20.108a10.45 10.45 0 0 1 7.416 3.07"
      ></path>
      <path
        fill="#DDB57A"
        d="M329.527 250.077a10.5 10.5 0 0 1 3.071 7.424 10.483 10.483 0 0 1-10.487 10.487h-20.116c-5.787 0-10.487-4.692-10.487-10.487s4.7-10.495 10.487-10.495h20.116c2.897 0 5.518 1.173 7.416 3.071"
      ></path>
      <path
        fill="#FCD18B"
        d="M322.441 250.077a10.46 10.46 0 0 0-7.417-3.071h-9.692c5.795 0 10.487-4.7 10.487-10.495 0-2.889-1.173-5.519-3.071-7.417a10.46 10.46 0 0 0-7.417-3.071h-9.692c5.795 0 10.495-4.7 10.495-10.495a10.489 10.489 0 0 0-10.496-10.488h-9.692c5.795 0 10.495-4.7 10.495-10.495 0-2.897-1.173-5.519-3.078-7.417a10.46 10.46 0 0 0-7.417-3.071h-20.108c-5.794 0-10.487 4.692-10.487 10.487s4.692 10.495 10.487 10.495h9.692c-5.795 0-10.495 4.692-10.495 10.487s4.7 10.495 10.495 10.495h9.692c-5.795 0-10.495 4.7-10.495 10.487 0 5.795 4.7 10.495 10.495 10.495h9.684c-5.787 0-10.487 4.7-10.487 10.495s4.7 10.487 10.487 10.487h20.116a10.483 10.483 0 0 0 10.487-10.487 10.48 10.48 0 0 0-3.068-7.421"
      ></path>
      <path
        fill="#DDB57A"
        d="M343.082 210.594s-38.813 3.722-38.813-26.536h9.748v1.903c0 13.604 11.029 24.633 24.633 24.633z"
      ></path>
      <path
        fill="#77BC4A"
        d="m287.24 166.141 5.795 17.919 20.982-.003-.496-17.916zM175.662 166.141l-8.369 17.919a17.87 17.87 0 0 1-12.668-5.251 17.88 17.88 0 0 1-5.243-12.668z"
      ></path>
      <path
        fill="#FC7A51"
        d="M251.052 166.149v17.911H211.85v-17.919h39.202z"
      ></path>
      <path
        fill="#FFF"
        d="M299.899 141.01c-1.654 6.306-7.385 10.952-14.203 10.952v-10.857a13 13 0 0 1 1.543-.094h12.66zM293.365 194.551c0-4.092-3.317-7.409-7.409-7.409s-5.354 3.317-5.354 7.409 1.262 7.409 5.354 7.409 7.409-3.317 7.409-7.409"
      ></path>
      <path fill="#E6E6E6" d="M140.446 281.168H6.964v-13.18h133.482z"></path>
      <path
        fill="#FFF"
        d="M311.473 236.515a7.41 7.41 0 0 0-7.408-7.409c-4.092 0-5.354 3.317-5.354 7.409s1.262 7.409 5.354 7.409a7.41 7.41 0 0 0 7.408-7.409M302.418 215.533a7.41 7.41 0 0 0-7.408-7.409c-4.092 0-5.354 3.317-5.354 7.409s1.262 7.409 5.354 7.409a7.41 7.41 0 0 0 7.408-7.409M321.55 257.497c0-4.092-3.317-7.409-7.409-7.409s-5.354 3.317-5.354 7.409 1.262 7.409 5.354 7.409 7.409-3.317 7.409-7.409"
      ></path>
      <path fill="#86D359" d="M449.626 189.318H400.71v78.67h49.994z"></path>
      <path fill="#77BC4A" d="M431.105 189.318h19.598v78.67h-19.598z"></path>
      <path
        fill="#6EC6EB"
        d="M140.5 175.889v146.898h-35.99l12.279 40.291h15.183c8.553 0 15.488-6.935 15.488-15.488V181.589a21 21 0 0 1-4.196-2.78 19 19 0 0 1-2.764-2.92m-8.528-82.051H34.737l10.831 35.54H140.5v36.763h6.959v-56.815c.001-8.553-6.934-15.488-15.487-15.488"
      ></path>
      <path
        fill="#FFF"
        d="M140.5 129.378H45.568l42.242 138.61h52.636v13.18h-48.62l12.684 41.619h35.99V175.889c-2.13-2.804-3.369-6.149-3.369-9.748h3.369z"
      ></path>
      <path
        fill="#ADE18E"
        d="M147.46 166.141h-10.329c0 3.599 1.24 6.944 3.369 9.748a19 19 0 0 0 2.763 2.92 21 21 0 0 0 4.196 2.78v-15.448"
      ></path>
      <path fill="#EEE" d="M140.446 267.988H87.81l4.016 13.18h48.62z"></path>
      <path
        fill="#FCD18B"
        d="M204.478 201.972a10.46 10.46 0 0 0 3.077-7.281c.078-5.847-5.005-10.631-10.853-10.631h-29.41a17.87 17.87 0 0 1-12.668-5.251 17.88 17.88 0 0 1-5.243-12.668h26.28a12.557 12.557 0 0 0 12.535-13.458c-.457-6.645-6.247-11.673-12.908-11.673h-24.49a64.7 64.7 0 0 0-29.886 7.306l-4.574 2.37a52.4 52.4 0 0 0-15.754 12.566 18 18 0 0 0-1.285 1.762c-9.78 14.997-26.225 24.305-44.129 24.305h-1.04v78.67h113.864c2.897 0 5.519-1.173 7.417-3.07a10.46 10.46 0 0 0 3.071-7.417c0-5.795-4.692-10.495-10.487-10.495h9.692a10.45 10.45 0 0 0 7.416-3.071 10.48 10.48 0 0 0 3.071-7.424c0-5.787-4.692-10.487-10.487-10.487h9.684c2.897 0 5.519-1.173 7.425-3.078a10.46 10.46 0 0 0 3.071-7.417c0-5.795-4.7-10.487-10.495-10.487h9.692a10.46 10.46 0 0 0 7.414-3.071"
      ></path>
      <path
        fill="#FFF"
        d="M164.247 141.01c1.654 6.306 7.385 10.952 14.203 10.952v-10.857a13 13 0 0 0-1.543-.094h-12.66z"
      ></path>
      <path fill="#FC7A51" d="M56.82 189.318H6.964v78.67h50.955z"></path>
      <path fill="#E86E4D" d="M6.964 189.318h19.598v78.67H6.964z"></path>
    </g>
  </svg>
  )
}
interface NumberOneProps{
  width?:number;
  height?:number;
  fill?:string;
}
const NumberOne = ({width,height,fill}:NumberOneProps) => {
  return(
     <svg  width={width ?? 30} height={height ?? 30}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g id="SVGRepo_iconCarrier">
      <path fill={fill ?? 'black'} d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3m0 24C9.925 27 5 22.075 5 16S9.925 5 16 5s11 4.925 11 11-4.925 11-11 11m-1.172-14.291q-.884.688-1.635.934v1.742a6.6 6.6 0 0 0 2.484-1.455v7.111h2.047v-10h-1.686a3.7 3.7 0 0 1-1.21 1.668"></path>
    </g>
  </svg>
  )
}

const NumberTwo = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g id="SVGRepo_iconCarrier">
      <path fill={fill ?? 'black'} d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3m0 24C9.925 27 5 22.075 5 16S9.925 5 16 5s11 4.925 11 11-4.925 11-11 11m1.564-9.223q.91-.834 1.26-1.278.526-.671.77-1.282.242-.612.242-1.289 0-1.19-.848-1.99c-.848-.8-1.342-.8-2.331-.8q-1.353 0-2.256.69c-.903.69-.96 1.218-1.073 2.275l1.914.191q.054-.84.41-1.201c.356-.361.555-.361.956-.361q.608 0 .952.345.345.346.346.988 0 .58-.396 1.176-.293.43-1.592 1.64-1.614 1.497-2.16 2.403c-.546.906-.584 1.242-.656 1.917h6.734V19.42h-3.819a3.3 3.3 0 0 1 .394-.534q.24-.274 1.153-1.109"></path>
    </g>
  </svg>
  )
}
const HorizontalLine = ({width,height,fill}:NumberOneProps) => {
  return(
      <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? 'black'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 12h16"
    ></path>
  </svg>
  )
}
const FilledCheckmarkCircle = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width ?? 30} height={height ?? 30} viewBox="0 0 56 56">
    <path
      fill={fill ?? 'black'}
      id="SVGRepo_iconCarrier"
      d="M28 51.906c13.055 0 23.906-10.828 23.906-23.906 0-13.055-10.875-23.906-23.93-23.906C14.899 4.094 4.095 14.945 4.095 28c0 13.078 10.828 23.906 23.906 23.906m-3.235-11.883c-.796 0-1.406-.351-2.085-1.148l-6.75-8.344c-.352-.445-.563-1.008-.563-1.523 0-1.102.867-1.945 1.898-1.945.68 0 1.243.257 1.805.984l5.602 7.242 10.898-17.46c.446-.727 1.055-1.079 1.664-1.079 1.032 0 2.04.68 2.04 1.805 0 .515-.305 1.078-.61 1.547L26.758 38.875c-.516.773-1.172 1.148-1.992 1.148"
    ></path>
  </svg>
  )
}
const EmptyCircle = ({width,height,fill}:NumberOneProps) => {
  return(
     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? 'black'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
    ></path>
  </svg>
  )
}
const QuestionButton = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <g id="SVGRepo_iconCarrier">
      <path
        stroke={fill ?? 'black'}
        strokeWidth="1.5"
        d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"
      ></path>
      <path
        stroke={fill ?? 'black'}
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M10.125 8.875a1.875 1.875 0 1 1 2.828 1.615c-.475.281-.953.708-.953 1.26V13"
      ></path>
      <circle cx="12" cy="16" r="1" fill={fill ?? 'black'}></circle>
    </g>
  </svg>
  )
}
const Shield = ({width,height,fill}:NumberOneProps) =>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? 'black'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 6h-1c-2.732 0-5.113-1.065-7-3-1.887 1.935-4.268 3-7 3H4v3.166C4 14.86 7.4 19.644 12 21c4.6-1.356 8-6.14 8-11.834z"
    />
  </svg>
  )
}
const Play = ({width,height,fill}:NumberOneProps) =>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 28 28" width={width ?? 30} height={height ?? 30}>
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g id="Icon-Set" fill={fill ??"#000"} transform="translate(-417 -569)">
          <path
            id="play"
            d="M418.983 594.247v-22.525l17.848 11.262zm19.221-12.711-18.81-12.257c-1.116-.607-2.394-.336-2.394 1.638v24.135c0 1.96 1.371 2.309 2.394 1.637l18.81-12.256c1.084-.768 1.054-2.191 0-2.897"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  );
}
const Pause = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 0 28 28" width={width ?? 30} height={height ?? 30}>
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g id="Icon-Set-Filled" fill={fill ??"#000"} transform="translate(-472 -571)">
          <path
            id="pauze"
            d="M490 571h-4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-24a2 2 0 0 0-2-2m-12 0h-4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-24a2 2 0 0 0-2-2"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  );
}
const Minimize = ({width,height,fill}:NumberOneProps) => {
  return(
     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <g
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#333"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M20 16h-2a2 2 0 0 0-2 2v2M4 8h2a2 2 0 0 0 2-2V4M4 16h2a2 2 0 0 1 2 2v2M20 8h-2a2 2 0 0 1-2-2V4"></path>
    </g>
  </svg>
  );
}
const Maximize = ({width,height,fill}:NumberOneProps) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <g
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#333"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M16 20h2a2 2 0 0 0 2-2v-2M8 4H6a2 2 0 0 0-2 2v2M8 20H6a2 2 0 0 1-2-2v-2M16 4h2a2 2 0 0 1 2 2v2"></path>
    </g>
  </svg>
  );
}
const Volume = ({width,height,fill}:NumberOneProps) =>{
  return(
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width={width ?? 30} height={height ?? 30}>
    <g id="SVGRepo_iconCarrier" fill={fill ?? "#000"}>
      <path d="M6 1h2v14H6l-4-4H0V5h2zM14 8a4 4 0 0 0-4-4V2a6 6 0 0 1 0 12v-2a4 4 0 0 0 4-4"></path>
      <path d="M12 8a2 2 0 0 1-2 2V6a2 2 0 0 1 2 2"></path>
    </g>
  </svg>
  );
}
const FreeBee = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width ?? 30} height={height ?? 30}>
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 7v13m0-13H8.464c-.52 0-1.02-.21-1.389-.586A2.02 2.02 0 0 1 6.5 5c0-.53.207-1.04.575-1.414A1.95 1.95 0 0 1 8.465 3C11.214 3 12 7 12 7m0 0h3.536c.52 0 1.02-.21 1.389-.586.368-.375.575-.884.575-1.414s-.207-1.04-.575-1.414A1.95 1.95 0 0 0 15.535 3C12.786 3 12 7 12 7m-7 5h14v5.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C17.48 21 16.92 21 15.8 21H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 19.48 5 18.92 5 17.8zm-.4 0h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 11.24 21 10.96 21 10.4V8.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 7 19.96 7 19.4 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 12 4.04 12 4.6 12"
    ></path>
  </svg>
  );
}
const SignOut = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -0.5 25 25" width={width ?? 30} height={height ?? 30}>
    <path
      id="SVGRepo_iconCarrier"
      fill={fill ?? "#000"}
      d="M11.75 9.874a.75.75 0 0 0 1.5 0zM13.25 4a.75.75 0 0 0-1.5 0zM9.81 6.662a.75.75 0 0 0-.62-1.366zM5.5 12.16l-.75-.004v.013zm7 6.84.009-.75h-.018zm7-6.84.75.009v-.013zm-3.69-6.864a.75.75 0 1 0-.62 1.366zm-2.56 4.578V4h-1.5v5.874zM9.19 5.296a7.58 7.58 0 0 0-4.44 6.86l1.5.008a6.08 6.08 0 0 1 3.56-5.502zM4.75 12.17a7.67 7.67 0 0 0 7.759 7.581l-.018-1.5a6.17 6.17 0 0 1-6.241-6.099zm7.741 7.581a7.67 7.67 0 0 0 7.759-7.581l-1.5-.018a6.17 6.17 0 0 1-6.241 6.099zm7.759-7.594a7.58 7.58 0 0 0-4.44-6.86l-.62 1.366a6.08 6.08 0 0 1 3.56 5.502z"
    ></path>
  </svg>
  );
}
const Cart = ({width,height,fill}:NumberOneProps) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
    <g id="SVGRepo_iconCarrier">
      <g clipPath="url(#clip0_15_35)">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
        <path
          stroke={fill??"#000"}
          strokeLinejoin="round"
          d="M5.333 6h14.534a1 1 0 0 1 .992 1.124l-.75 6a1 1 0 0 1-.992.876H8"
        ></path>
        <path
          stroke={fill??"#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2 4h2.234a1 1 0 0 1 .965.74l3.102 11.52a1 1 0 0 0 .965.74H19"
        ></path>
        <circle
          cx="10"
          cy="20"
          r="1"
          stroke={fill??"#000"}
          strokeLinejoin="round"
        ></circle>
        <circle
          cx="17.5"
          cy="20"
          r="1"
          stroke={fill??"#000"}
          strokeLinejoin="round"
        ></circle>
      </g>
      <defs>
        <clipPath id="clip0_15_35">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </g>
  </svg>
  );
}
export const Icon = {
    FacebookIcon,
    InstagramIcon,
    CheckMarkCircle,
    CheckMarkCross,
    LinkedInIcon,
    MenuIcon,
    KlarnaWhite,
    KlarnaOffWhiteTransparent,
    Heart,
    Brain,
    Leaf,
    CheckMarkWide,
    StarRainbow,
    Calendar,
    GraduationCap,
    Exam,
    Lecture,
    Cash,
    AlternativeLeaf,
    Gift,
    ArrowUp,
    ArrowDown,
    LeafGrow,
    Compass,
    Bullseye,
    LeafAndHandsGrow,
    AwardBadge,
    Nature,
    Star,
    ThinkingAvatar,
    ChatCloud,
    SwishIcon,
    StripeIcon,
    KlarnaPink,
    ArrowRight,
    SimpleGroup,
    TestLogoNav,
    LogIn,
    CheckoutPayment,
    NumberOne,
    NumberTwo,
    HorizontalLine,
    FilledCheckmarkCircle,
    EmptyCircle,
    QuestionButton,
    Shield,
    ArrowLeft,
    Play,
    Pause,
    Maximize,
    Minimize,
    Volume,
    FreeBee,
    SignOut,
    Cart
}
